import {Inject, Injectable, OnDestroy, Optional} from '@angular/core';
import {BehaviorSubject, debounceTime, Observable, tap} from 'rxjs';
import {
  AangeverBurgerlijkeStaat,
  AangeverSamenwoonSituatie,
  Aangifte,
  AangifteBerekening,
  AangifteRapport,
  Adres,
  BOKKZ_BASE_URL,
  BokkzClient,
  Herinvesteringsreserve,
  IncomeTaxEntity,
  JaarrekeningBalans,
  JaarrekeningInvesteringen,
  JaarrekeningVenW,
  Kind,
  Lening,
  LeningAanwending,
  LeningGeldVerstrekker,
  MenuInterface,
  OmschrijvingEnBedrag,
  Onderneming,
  Ondernemingsvorm,
  OnroerendeZaak,
  ResultaatSamenwerking,
  SpecificatieOnroerendeZaken,
  SpecificatiePriveGebruikAuto,
  SpecificatiePriveGebruikWoning,
  Staking,
  VerhuurdOfVerpachtStatus,
  Voorheffingen
} from './api.bokkz.services';
import {Bevinding, ControleRequest, ErrorMessage, IbRekenService, UitlegResponse} from './rekenclient.api';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '@snelstart/ui-toast';
import {BokkzClientLoonheffingen} from './api.bokkz.loonheffingen';

@Injectable({providedIn: 'root'})
export class BokkzIbDataService implements OnDestroy {

  public optimaleAangifte = new BehaviorSubject<Aangifte>(this.getFromSessionStorage<Aangifte>('optimaleAangifte') || {} as Aangifte);
  public aangifteBerekening = new BehaviorSubject<AangifteBerekening>(this.getFromSessionStorage<AangifteBerekening>('aangifteBerekening') || {});
  public partnerAangifteBerekening = new BehaviorSubject<AangifteBerekening>(this.getFromSessionStorage<AangifteBerekening>('partnerAangifteBerekening') || {});
  public optimaleBerekening = new BehaviorSubject<AangifteBerekening>(this.getFromSessionStorage<AangifteBerekening>('optimaleBerekening') || {});
  public aangifteRapport = new BehaviorSubject<AangifteRapport>(this.getFromSessionStorage<AangifteRapport>('aangifteRapport') || {});
  public partnerAangifteRapport = new BehaviorSubject<AangifteRapport>(this.getFromSessionStorage<AangifteRapport>('partnerAangifteRapport') || {});
  public incomeTaxEntity = new BehaviorSubject<IncomeTaxEntity>(this.getFromSessionStorage<IncomeTaxEntity>('incomeTaxEntity') || {} as IncomeTaxEntity);
  public controleResponse = new BehaviorSubject<Bevinding[]>([]);
  public errorResponse = new BehaviorSubject<ErrorMessage[]>([]);
  public aantalValidaties = new BehaviorSubject<number>(0);
  public aantalBevindingen = new BehaviorSubject<number>(0);
  public naamAangever = '';
  public naamPartner = '';
  public heeftWinstUitOndernemingAangever = new BehaviorSubject<boolean>(false);
  public heeftWinstUitOndernemingPartner = new BehaviorSubject<boolean>(false);
  public drempelZorgkosten = new BehaviorSubject<number>(0);
  public drempelGiften = new BehaviorSubject<number>(0);
  public uitlegResponse = new BehaviorSubject<UitlegResponse>(this.getFromSessionStorage<UitlegResponse>('uitleg') || {} as UitlegResponse);
  public options = new BehaviorSubject<MenuInterface[]>([]);
  public errorString = '';
  public controleRequest = {} as ControleRequest;
  public menuInterface = new BehaviorSubject<MenuInterface[]>([]);
  public isDefAangifte = new BehaviorSubject<boolean>(false);
  public isVerzoek = new BehaviorSubject<boolean>(false);
  public heeftLoonMeerdere = new BehaviorSubject<boolean>(false);
  public heeftLoonAangever = new BehaviorSubject<boolean>(false);
  public heeftLoonTegenwoordigAangever = new BehaviorSubject<boolean>(false);
  public heeftLoonPartner = new BehaviorSubject<boolean>(false);
  public heeftLoonTegenwoordigPartner = new BehaviorSubject<boolean>(false);
  public heeftOverigInkomen = new BehaviorSubject<boolean>(false);
  public heeftEigenWoning = new BehaviorSubject<boolean>(false);
  public heeftPremiesInkomensvoorzieningenAangever = new BehaviorSubject<boolean>(false);
  public heeftPremiesInkomensvoorzieningenPartner = new BehaviorSubject<boolean>(false);
  public heeftBox2 = new BehaviorSubject<boolean>(false);
  public heeftBox3 = false
  public heeftBox3Samenvatting = new BehaviorSubject<boolean>(false);
  public vermogensGrensVoorRegelingen = 0;
  public heeftPga = new BehaviorSubject<boolean>(false);
  public hasVerdeling = false;
  public hasVerdelingRendementsGrondslag = false;
  public hasVerdelingGezien = new BehaviorSubject<boolean>(false);
  public isKwalificerendBtl = new BehaviorSubject<boolean>(false);
  public heeftAangeverWuo = new BehaviorSubject<boolean>(false);
  public heeftPartnerWuo = new BehaviorSubject<boolean>(false);
  public heeftSamenwerkingsverbandWuoAangever = new BehaviorSubject<boolean>(false);
  public heeftSamenwerkingsverbandWuoPartner = new BehaviorSubject<boolean>(false);
  public heeftSamenwerkingsverbandWuo = new BehaviorSubject<boolean>(false);
  public heeftEenmanszaakWuoAangever = new BehaviorSubject<boolean>(false);
  public heeftEenmanszaakWuoPartner = new BehaviorSubject<boolean>(false);
  private apiAnbiUrl = 'https://portaal.belastingdienst.nl/anbi-service/api/search';
  private baseUrl: string;
  public box3LeningenGeinitialiseerdVoor = new Set<string>();
  public box3LeningenVerwijderd = new Set<string>();

    constructor(private ibRekenService: IbRekenService,
              private ibLoonheffingService: BokkzClientLoonheffingen,
              private toastService: ToastService,
              private bokkzClient: BokkzClient,
              private fb: FormBuilder,
              private http: HttpClient,
              @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string
  ) {
    this.applyDebounceTime();
    this.replaceEmptyArraysWithUndefined = this.replaceEmptyArraysWithUndefined.bind(this);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  private applyDebounceTime() {
    const debounceDelay = 500; // Timeout voor toetsaanslagen
    this.optimaleAangifte = this.optimaleAangifte.pipe(
      tap((value) => this.saveToSessionStorage('optimaleAangifte', value))) as BehaviorSubject<Aangifte>;
    this.aangifteBerekening = this.aangifteBerekening.pipe(
      tap((value) => this.saveToSessionStorage('aangifteBerekening', value))) as BehaviorSubject<AangifteBerekening>;
    this.partnerAangifteBerekening = this.partnerAangifteBerekening.pipe(
      tap((value) => this.saveToSessionStorage('partnerAangifteBerekening', value))) as BehaviorSubject<AangifteBerekening>;
    this.optimaleBerekening = this.optimaleBerekening.pipe(
      tap((value) => this.saveToSessionStorage('optimaleBerekening', value))) as BehaviorSubject<AangifteBerekening>;
    this.aangifteRapport = this.aangifteRapport.pipe(
      tap((value) => this.saveToSessionStorage('aangifteRapport', value))) as BehaviorSubject<AangifteRapport>;
    this.partnerAangifteRapport = this.partnerAangifteRapport.pipe(
      tap((value) => this.saveToSessionStorage('partnerAangifteRapport', value))) as BehaviorSubject<AangifteRapport>;
    this.incomeTaxEntity.pipe(
      debounceTime(500),
      tap((value) => this.saveToSessionStorage('incomeTaxEntity', value))).subscribe();

    this.errorResponse = this.errorResponse as BehaviorSubject<ErrorMessage[]>;
    this.controleResponse = this.controleResponse as BehaviorSubject<Bevinding[]>;
    this.aantalValidaties = this.aantalValidaties as BehaviorSubject<number>;
  }

  //Voor het ophalen uit de sessionstorage.
  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  //Voor het opslaan in sessionstorage
  private saveToSessionStorage(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  private getNaamAangeverEnPartner(incomeTaxEntity: IncomeTaxEntity) {
    if (this.incomeTaxEntity) {
      const aangifte = incomeTaxEntity.aangifte;
      if (aangifte && aangifte.aangever != null && aangifte.aangever.achternaam != null) {
        let voorletters = '';
        let tussenvoegsel = '';
        let achternaam = '';
        if (aangifte.aangever.voorletters) {
          voorletters = aangifte.aangever.voorletters.replace(/\./g, '');
        }
        if (aangifte.aangever.tussenvoegsels) {
          tussenvoegsel = aangifte.aangever.tussenvoegsels;
        }
        if (aangifte.aangever.achternaam) {
          achternaam = aangifte.aangever.achternaam;
        }
        if (tussenvoegsel) {
          this.naamAangever = voorletters + ' ' + tussenvoegsel + ' ' + achternaam;
        } else {
          this.naamAangever = voorletters + ' ' + achternaam;
        }
      } else {
        this.naamAangever = 'aangever';
      }
      if (aangifte && aangifte.partnerAangifte != null && aangifte.partnerAangifte.aangever != null) {
        aangifte.partnerAangifte.gezamenlijkeAangifte = true;
        aangifte.gezamenlijkeAangifte = true;
      } else if (aangifte && aangifte.partnerAangifte == null) {
        aangifte.gezamenlijkeAangifte = false;
      }

      if (aangifte && aangifte.partnerAangifte != null && aangifte.partnerAangifte.aangever != null &&
        aangifte.partnerAangifte.aangever.achternaam != null) {
        let voorletters = '';
        let tussenvoegsel = '';
        let achternaam = '';
        if (aangifte.partnerAangifte.aangever.voorletters) {
          voorletters = aangifte.partnerAangifte.aangever.voorletters.replace(/\./g, '');
        }
        if (aangifte.partnerAangifte.aangever.tussenvoegsels) {
          tussenvoegsel = aangifte.partnerAangifte.aangever.tussenvoegsels;
        }
        if (aangifte.partnerAangifte.aangever.achternaam) {
          achternaam = aangifte.partnerAangifte.aangever.achternaam;
        }

        if (tussenvoegsel) {
          this.naamPartner = voorletters + ' ' + tussenvoegsel + ' ' + achternaam;
        } else {
          this.naamPartner = voorletters + ' ' + achternaam;
        }
      } else {
        this.naamPartner = 'partner';
      }
    }
  }

  updateHasVerdelingGezien(gezien: boolean) {
    this.hasVerdelingGezien.next(gezien);
  }

  updateOptimaleAangifte(optimaleAangifte: Aangifte) {
    this.saveToSessionStorage('optimaleAangifte', optimaleAangifte);
    this.optimaleAangifte.next(optimaleAangifte);
  }

  updateAangifteBerekening(aangifteBerekening: AangifteBerekening) {
    this.aangifteBerekening.next(aangifteBerekening);
    this.heeftGrondslagBox3(aangifteBerekening);
    this.saveToSessionStorage('aangifteBerekening', aangifteBerekening);
  }

  updateOptimaleBerekening(optimaleBerekening: AangifteBerekening) {
    this.optimaleBerekening.next(optimaleBerekening);
  }

  updatePartnerAangifteBerekening(aangifteBerekening: AangifteBerekening) {
    this.heeftGrondslagBox3(aangifteBerekening);
    this.partnerAangifteBerekening.next(aangifteBerekening);
  }

  updateAangifteRapport(aangifteRapport: AangifteRapport) {
    this.aangifteRapport.next(aangifteRapport);
  }

  updatePartnerAangifteRapport(partnerAangifteRapport: AangifteRapport) {
    this.partnerAangifteRapport.next(partnerAangifteRapport);
  }

  heeftGrondslagBox3(berekening: AangifteBerekening) {
    this.heeftBox3 = false
    if (berekening.box3?.opbouwInkomen?.grondslagSparenEnBeleggen &&
      berekening.box3?.opbouwInkomen?.grondslagSparenEnBeleggen > 0) {
      this.heeftBox3 = true
    }
  }

  // verwijderen lege arrays
  private isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  private replaceEmptyArraysWithUndefined = (obj: any): any => {
    if (Array.isArray(obj)) {
      // Als het een array is en de lengte is 0 of 1 met een leeg object erin, vervang het met undefined
      if (obj.length === 0) {
        return undefined;
      } else if (obj.length === 1 && this.isEmptyObject(obj[0])) {
        return undefined;
      } else {
        // Als het geen lege array is of geen array met alleen een leeg object, blijf recursief doorlopen
        // Als het geen lege array is of geen array met alleen een leeg object, blijf recursief doorldateopen
        return obj.map(this.replaceEmptyArraysWithUndefined);
      }
    } else if (typeof obj === 'object' && obj !== null) {
      // Als het een object is, doorloop alle eigenschappen
      Object.keys(obj).forEach(key => {
        obj[key] = this.replaceEmptyArraysWithUndefined(obj[key]);
      });
    }
    return obj;
  };

  updateIncomeTaxEntity(incomeTaxEntity: IncomeTaxEntity) {
    const isVerzoek = this.createIsVerzoek(incomeTaxEntity);
    if (isVerzoek) {
      this.isDefAangifte.next(false);
    } else {
      this.isDefAangifte.next(true);
    }
    this.updateVerzoek(isVerzoek);

    if (incomeTaxEntity.aangifte) {
      let aangifte = incomeTaxEntity.aangifte;

      if (aangifte.verdeling) {
        this.hasVerdelingGezien.next(true);
      }

        if (aangifte.buitenlandseBelastingplicht?.belastingplichtigeVoldoetAanVoorwaardenKwalificatie || aangifte.partnerAangifte?.buitenlandseBelastingplicht?.belastingplichtigeVoldoetAanVoorwaardenKwalificatie) {
            this.isKwalificerendBtl.next(true);
        } else {
            this.isKwalificerendBtl.next(false);
        }

      this.getNaamAangeverEnPartner(incomeTaxEntity);

      // verwijderen lege arrays
      // this.removeEmptyObjects(incomeTaxEntity.aangifte);
      this.replaceEmptyArraysWithUndefined(incomeTaxEntity.aangifte);

      aangifte = this.schoonAangifte(aangifte);

      if (aangifte?.partnerAangifte != null) {

        if (aangifte?.partnerAangifte?.aangever?.tussenvoegsels !== undefined) {
          const tussenvoegsels = aangifte.partnerAangifte.aangever.tussenvoegsels;
          if (tussenvoegsels === null) {
            aangifte.partnerAangifte.aangever.tussenvoegsels = undefined;
          } else {
            if (!/[a-zA-Z]/.test(tussenvoegsels.trim())) {
              aangifte.partnerAangifte.aangever.tussenvoegsels = undefined;
            }
          }
        }

        const relatiegegevens = aangifte.aangever.relatiegegevens;
        if (relatiegegevens && Array.isArray(relatiegegevens)) {
          relatiegegevens.forEach(relatie => {
            if (relatie.datumOverlijdenPartner !== undefined && relatie.datumOverlijdenPartner !== null && aangifte.partnerAangifte) {
              aangifte.partnerAangifte.biljetSoort = 'F';
              aangifte.partnerAangifte.aangever.overlijdensdatum = relatie.datumOverlijdenPartner;
            }
            if ((relatie.datumOverlijdenPartner == undefined || relatie.datumOverlijdenPartner == null) && aangifte.partnerAangifte) {
              aangifte.partnerAangifte.biljetSoort = 'P';
            }
          });
        }
      }

      if (aangifte?.aangever) {
        const letters = aangifte.aangever.voorletters;
        if (!letters || letters.trim() === '') {
          aangifte.aangever.voorletters = undefined;
        }
      }

      if (aangifte?.partnerAangifte?.aangever) {
        const letters = aangifte.partnerAangifte?.aangever?.voorletters;
        const aangeverPartner = aangifte.partnerAangifte?.aangever;
        if (aangeverPartner && (!letters || letters.trim() === '')) {
          aangeverPartner.voorletters = undefined;
        }
      }

      //burgerlijke staat
      if (aangifte?.aangever?.burgerlijkeStaat !== undefined) {
        if (aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.ALLEENSTAAND ||
          (aangifte?.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND &&
            aangifte?.aangever.samenwoonSituatie === AangeverSamenwoonSituatie.GEEN)) {
          aangifte.partnerAangifte = undefined;
          aangifte.gezamenlijkeAangifte = undefined;
          const optimaleAangifte = sessionStorage.getItem('optimaleAangifte');
          if (optimaleAangifte !== null) {
            sessionStorage.removeItem('optimaleAangifte');
            sessionStorage.removeItem('optimaleBerekening');
            sessionStorage.removeItem('partnerAangifteRapport');
          }
        }

        if (aangifte.aangever.burgerlijkeStaat === 'GEHUWD' ||
          (aangifte.aangever.burgerlijkeStaat === 'SAMENWONEND' && aangifte.aangever.samenwoonSituatie !== 'GEEN') ||
          (aangifte.aangever.burgerlijkeStaat === 'SITUATIE_GEWIJZIGD' &&
            aangifte.aangever.relatiegegevens !== undefined &&
            aangifte.aangever.relatiegegevens.length > 0 &&
            aangifte.aangever.relatiegegevens[0].voldaanAanFiscaalPartnerschapVoorwaarden === true &&
            aangifte.aangever.relatiegegevens[0].kiestVoorHeleJaarPartnerschap === true)) {
          aangifte.gezamenlijkeAangifte = true;
          if (aangifte.partnerAangifte == undefined) {
            aangifte.partnerAangifte ??= {
              aangever: {
                geboortedatum: undefined as unknown as Date,
                achternaam: undefined as unknown as string,
                voorletters: undefined as unknown as string,
                bsn: undefined as unknown as string,
                burgerlijkeStaat: aangifte.aangever.burgerlijkeStaat
              },
              aangifteJaar: aangifte.aangifteJaar,
              biljetSoort: 'P',
              gezamenlijkeAangifte: true
            };
          } else {
            if (aangifte.aangever.burgerlijkeStaat != undefined) {
              aangifte.partnerAangifte.aangever.burgerlijkeStaat = aangifte.aangever.burgerlijkeStaat;
            }
            if (aangifte.aangever.samenwoonSituatie != undefined) {
              aangifte.partnerAangifte.aangever.samenwoonSituatie = aangifte.aangever.samenwoonSituatie;
            }
            if (aangifte.aangever.relatiegegevens != undefined) {
              aangifte.partnerAangifte.aangever.relatiegegevens = aangifte.aangever.relatiegegevens;
            }
            if (aangifte.aangever.relatiegegevens == undefined) {
              aangifte.partnerAangifte.aangever.relatiegegevens = undefined;
            }
          }
        }

        if (aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.GEHUWD || aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.ALLEENSTAAND || aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SITUATIE_GEWIJZIGD) {
          aangifte.aangever.samenwoonSituatie = undefined;
          if (aangifte.partnerAangifte && aangifte.partnerAangifte.aangever) {
            aangifte.partnerAangifte.aangever.samenwoonSituatie = undefined;
          }
        }

        if (aangifte?.aangever?.relatiegegevens !== undefined) {
          const relatie = aangifte.aangever.relatiegegevens;
          if (Array.isArray(relatie) && relatie.length > 0) {
            if (relatie[0].kiestVoorHeleJaarPartnerschap !== undefined && !relatie[0].kiestVoorHeleJaarPartnerschap) {
              aangifte.gezamenlijkeAangifte = false;
              aangifte.partnerAangifte = undefined;
            }

            if (!relatie[0].voldaanAanFiscaalPartnerschapVoorwaarden) {
              relatie[0].kiestVoorHeleJaarPartnerschap = false;
              aangifte.partnerAangifte = undefined;
              aangifte.gezamenlijkeAangifte = false;
            }

            if (relatie[0].kiestVoorHeleJaarPartnerschap) {
              aangifte.gezamenlijkeAangifte = true;
              if (aangifte.aangever.relatiegegevens && aangifte.partnerAangifte && aangifte.partnerAangifte.aangever) {

                aangifte.partnerAangifte.aangever.relatiegegevens = structuredClone(aangifte.aangever.relatiegegevens);
                aangifte.partnerAangifte.aangever.relatiegegevens[0].datumOverlijdenPartner = undefined;
              }
            }
          }
        }
      }

      if (aangifte?.aangever?.bsn != null) {
        aangifte.aangever.bsn = aangifte.aangever.bsn.padStart(9, '0');
      }
      if (aangifte?.partnerAangifte && aangifte.partnerAangifte?.aangever?.bsn != null) {
        aangifte.partnerAangifte.aangever.bsn = aangifte.partnerAangifte.aangever.bsn.padStart(9, '0');
      }

      //gezamenlijke aangifte
      if (aangifte.gezamenlijkeAangifte === false) {
        if (aangifte.partnerAangifte?.box1) {
          aangifte.partnerAangifte.box1 = undefined;
        }
        if (aangifte.partnerAangifte?.voorheffingen) {
          aangifte.partnerAangifte.voorheffingen = undefined;
        }
      }

      //gezamenlijke aangifte & heffingskortingen
      if (aangifte?.gezamenlijkeAangifte === true && aangifte?.heffingskortingen) {
        const heffingskortingen = aangifte.heffingskortingen;
        if (heffingskortingen) {
          heffingskortingen.geboortedatumPartner = undefined;
          heffingskortingen.arbeidsInkomenPartner = undefined;
          heffingskortingen.verzamelInkomenPartner = undefined;
        }
      }

      if (aangifte.kinderen?.length === 0) {
        aangifte.kinderen = undefined;
      }

      if ((aangifte.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.GEHUWD && aangifte.gezamenlijkeAangifte) ||
        (aangifte.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND && aangifte.gezamenlijkeAangifte)) {
        const kinderen = aangifte?.kinderen;
        if (kinderen && Array.isArray(kinderen)) {
          kinderen.forEach(kinderen => {
            if (kinderen.ingeschrevenOpAdresAangever !== undefined) {
              kinderen.ingeschrevenOpAdresPartner = kinderen.ingeschrevenOpAdresAangever;
            }
          });
        }
      }

        if (aangifte.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.SITUATIE_GEWIJZIGD && aangifte.gezamenlijkeAangifte) {
            const kinderen = aangifte?.kinderen;
            if (kinderen && Array.isArray(kinderen)) {
                kinderen.forEach(kinderen => {
                    if (!kinderen.ingeschrevenOpAdresAangever) {
                        kinderen.coOuderschap = false;
                    }
                });
            }
        }

      //lege buitenlandse belastingplicht
      if (aangifte.biljetSoort !== 'C') {
        aangifte.buitenlandseBelastingplicht = undefined;
      }
      if (aangifte.partnerAangifte !== undefined && aangifte.partnerAangifte?.biljetSoort !== 'C') {
        if (aangifte.partnerAangifte.buitenlandseBelastingplicht) {
          aangifte.partnerAangifte!.buitenlandseBelastingplicht = undefined;
        }
      }

      // lege boxen
      if (aangifte.box1 && Object.keys(aangifte.box1).length === 0) {
        aangifte.box1 = undefined;
      }
      if (aangifte.box2 && Object.keys(aangifte.box2).length === 0) {
        aangifte.box2 = undefined;
      }
      if (aangifte.box3 && Object.keys(aangifte.box3).length === 0) {
        aangifte.box3 = undefined;
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && Object.keys(aangifte.partnerAangifte.box1).length === 0) {
        aangifte.partnerAangifte.box1 = undefined;
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box2 && Object.keys(aangifte.partnerAangifte.box2).length === 0) {
        aangifte.partnerAangifte.box2 = undefined;
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box3) {
        aangifte.partnerAangifte.box3 = undefined;
      }

      // wuo
      if (aangifte.box1?.winstUitOnderneming == undefined) {
        this.heeftAangeverWuo.next(false);
      }
      if (aangifte.partnerAangifte?.box1?.winstUitOnderneming == undefined) {
        this.heeftPartnerWuo.next(false);
      }
      if (aangifte.box1?.winstUitOnderneming == undefined) {
        this.heeftPartnerWuo.next(false);
      }

      if (this.heeftSamenwerkingsverbandWuoAangever || this.heeftSamenwerkingsverbandWuoPartner) {
        this.heeftSamenwerkingsverbandWuo.next(false);
        if (this.heeftSamenwerkingsverbandWuoAangever.value || this.heeftSamenwerkingsverbandWuoPartner.value) {
          this.heeftSamenwerkingsverbandWuo.next(true);
        }
      }
      if (aangifte.box1?.winstUitOnderneming != undefined) {
        const wuo = aangifte?.box1?.winstUitOnderneming;
        let oudedagsreserveBeginJaar = 0;
        if (wuo) {
          const ondernemingen = wuo?.ondernemingen;
          if (Array.isArray(ondernemingen) && ondernemingen.length === 0) {
            if (aangifte.box1 && aangifte.box1.winstUitOnderneming)
              aangifte.box1.winstUitOnderneming.krijgtZelfstandigenAftrek = undefined;
            aangifte.box1.winstUitOnderneming.krijgtStartersAftrek = undefined;
            aangifte.box1.winstUitOnderneming.krijgtSenOaftrek = undefined;
            aangifte.box1.winstUitOnderneming.krijgtVerhogingSenOAftrek = undefined;
            aangifte.box1.winstUitOnderneming.meewerkUren = undefined;
          }
          if (Array.isArray(ondernemingen) && ondernemingen.length > 0) {
            this.heeftAangeverWuo.next(true);
            ondernemingen[0].agrarischeActiviteiten = ondernemingen[0].agrarischeActiviteiten ?? undefined;

            if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK) {
              ondernemingen[0].resultaatSamenwerking = undefined;
              ondernemingen[0].invullenOpPersoonlijkNiveau = undefined;
              ondernemingen[0].invullenOpNiveauSamenwerkingsverband = undefined;
              ondernemingen[0].invullenOpJaaropgaveCV = undefined;
              ondernemingen[0].rsin = undefined;
            }

            this.heeftSamenwerkingsverbandWuoAangever.next(false);
            this.heeftEenmanszaakWuoAangever.next(false);
            if (ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK) {
              if (ondernemingen[0].invullenOpNiveauSamenwerkingsverband) {
                ondernemingen[0].invullenOpPersoonlijkNiveau = false;
                this.heeftSamenwerkingsverbandWuoAangever.next(true);
                if (ondernemingen[0].resultaatSamenwerking) {
                  ondernemingen[0].resultaatSamenwerking.aandeelBelastingplichtigeInKapitaalOverig = 0;
                  if (ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige = 0;
                  }
                  if (ondernemingen[0].resultaatSamenwerking.vergoedingVoorArbeidBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.vergoedingVoorArbeidBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.vergoedingVoorArbeidBelastingplichtige = 0;
                  }
                  if (ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige = 0;
                  }
                  if (ondernemingen[0].resultaatSamenwerking.overigeVergoedingenBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.overigeVergoedingenBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.overigeVergoedingenBelastingplichtige = 0;
                  }
                }
              } else {
                ondernemingen[0].invullenOpPersoonlijkNiveau = true;
                this.heeftSamenwerkingsverbandWuoAangever.next(false);
              }
            } else if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK) {
              this.heeftEenmanszaakWuoAangever.next(true);
            }

            if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK ||
              ondernemingen[0].invullenOpPersoonlijkNiveau
            ) {
              ondernemingen[0].resultaatSamenwerking = undefined;
            }


            if (ondernemingen[0].investeringen && Array.isArray(ondernemingen[0].investeringen)) {
              ondernemingen[0].investeringen.forEach(investering => {

                if (investering.investeringsbedragKIA === undefined) {
                  investering.claimKIA = undefined;
                }
                if (investering.investeringsbedragEIA === undefined) {
                  investering.claimEIA = undefined;
                }
                if (investering.investeringsbedragMIA === undefined) {
                  investering.claimMIA = undefined;
                }
                if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK ||
                  ((ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.VOF || ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.MAATSCHAP)
                    && !ondernemingen[0].invullenOpNiveauSamenwerkingsverband)
                ) {
                  if (investering.investeringsbedragKIA !== undefined) {
                    investering.aandeelInInvesteringsBedrag = investering.investeringsbedragKIA;
                  } else if (investering.investeringsbedragEIA != undefined || investering.investeringsbedragMIA != undefined) {
                        investering.aandeelInInvesteringsBedrag = investering.investeringsbedragEIA != undefined ? investering.investeringsbedragEIA : investering.investeringsbedragMIA
                    }
                }
              });
            }
              ondernemingen.forEach(onderneming => {
                  ['financieleBaten', 'buitengewoneBaten', 'financieleLasten', 'buitengewoneLasten'].forEach(key => {
                      if (onderneming[key]) {
                          onderneming[key] = onderneming[key].map((item: Onderneming) => (item === null ? undefined : item));
                      }
                  });

                  if (onderneming.werkzaamheden) {
                      let werkzaamheden = this.sanitizeText(onderneming.werkzaamheden);
                      werkzaamheden = werkzaamheden.substring(0, 70);
                      onderneming.werkzaamheden = werkzaamheden;
                  }

                  if (onderneming.naam) {
                      onderneming.naam = this.sanitizeText(onderneming.naam);
                  }

                  if (onderneming.schadeloosstellingBuitenWinstOm === false) {
                      onderneming.schadeloosstellingBuitenWinst = undefined;
                  }

                  onderneming.materieleVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null);
                  onderneming.immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null);
                  onderneming.vlottendeActivaVoorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null);
                  onderneming.vlottendeActivaVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null);
                  onderneming.financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null);
                  onderneming.liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null);
                  onderneming.effecten = onderneming?.effecten?.filter(item => item !== null);

                  onderneming.eigenVermogen = onderneming?.eigenVermogen?.filter(item => item !== null);
                  onderneming.eigenVermogen = onderneming?.eigenVermogen?.filter(
                      item => item !== null && !item.omschrijving?.includes('fiscaalOndernemingsVermogen')
                  );
                  onderneming.voorzieningen = onderneming?.voorzieningen?.filter(item => item !== null);
                  onderneming.langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null);
                  onderneming.kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null);

                  onderneming.wuoOpbrengsten = onderneming?.wuoOpbrengsten?.filter(kosten => kosten && kosten.bedrag !== undefined);
                  onderneming.wuoStakingswinsten = onderneming?.wuoStakingswinsten?.filter(kosten => kosten && kosten.bedrag !== undefined);
                  onderneming.wuoVrijgesteldeWinstbestanddelen = onderneming?.wuoVrijgesteldeWinstbestanddelen?.filter(kosten => kosten.bedrag !== undefined);
                  onderneming.financieleBaten = onderneming?.financieleBaten?.filter(kosten => kosten && kosten.bedrag !== undefined);
                  onderneming.financieleLasten = onderneming?.financieleLasten?.filter(kosten => kosten && kosten.bedrag !== undefined);
                  onderneming.buitengewoneBaten = onderneming?.buitengewoneBaten?.filter(kosten => kosten && kosten.bedrag !== undefined);
                  onderneming.buitengewoneLasten = onderneming?.buitengewoneLasten?.filter(kosten => kosten && kosten.bedrag !== undefined);

                  onderneming.wuoKosten = onderneming?.wuoKosten?.filter(kosten => kosten && kosten.bedrag !== undefined);
                  onderneming.wuoKosten = onderneming?.wuoKosten?.filter(kosten => kosten && kosten.bedrag !== null);

                  onderneming.investeringen = onderneming?.investeringen?.filter(item => item !== null);
                  onderneming.restantInvesteringsaftrek = onderneming?.restantInvesteringsaftrek?.filter(item => item !== null);

                  onderneming.onttrekkingenOverig = onderneming?.onttrekkingenOverig?.filter(item => item !== null);
                  onderneming.onttrekkingOG = onderneming?.onttrekkingOG?.filter(item => item !== null);
                  onderneming.onttrekkingPriveGebruikAuto = onderneming?.onttrekkingPriveGebruikAuto?.filter(item => item !== null);
                  onderneming.onttrekkingPriveGebruikWoning = onderneming?.onttrekkingPriveGebruikWoning?.filter(item => item !== null);

                  onderneming.stortingenOverig = onderneming?.stortingenOverig?.filter(item => item !== null);
                  onderneming.stortingOG = onderneming?.stortingOG?.filter(item => item !== null);

                  onderneming.nietAftrekbareKosten = onderneming?.nietAftrekbareKosten?.filter(item => item !== null);
                  onderneming.beperktAftrekbareKosten = onderneming?.beperktAftrekbareKosten?.filter(item => item !== null);

                  if (onderneming.datumStaking === null && onderneming.staking !== undefined) {
                      onderneming.staking = undefined;
                  }
                  if (onderneming.datumStaking === null && onderneming.wuoStakingswinsten !== undefined) {
                      onderneming.wuoStakingswinsten = undefined;
                  }

                  const eigenVermogen = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'eigenVermogen');
                  if (eigenVermogen) {
                      eigenVermogen.waardeSlot = this.berekenEigenVermogenSlot(onderneming);
                      eigenVermogen.waardeOpening = this.berekenEigenVermogenOpening(onderneming);
                  }

                  const oudedagsReserve = onderneming?.eigenVermogen?.find(
                      (item: any) => item.omschrijving === 'oudedagsReserve');
                  if (oudedagsReserve) {
                      const waardeOpening = oudedagsReserve.waardeOpening || 0;
                      const waardeSlot = oudedagsReserve.waardeSlot || 0;
                      onderneming.beginstandFOR = oudedagsReserve.waardeOpening;
                      const vrijvalFOR = waardeOpening - waardeSlot;
                      if (waardeOpening === 0) {
                          onderneming.beginstandFOR = undefined;
                      }
                      if (vrijvalFOR > 0) {
                          onderneming.vrijvalFOR = vrijvalFOR;
                      } else {
                          onderneming.vrijvalFOR = undefined;
                      }
                      oudedagsreserveBeginJaar += waardeOpening;
                  }

                  const herinvesteringsReserve = onderneming?.eigenVermogen?.find(
                      (item: any) => item.omschrijving === 'herinvesteringsReserve');

                  if (herinvesteringsReserve) {
                      const waardeOpening = herinvesteringsReserve.waardeOpening;
                      const waardeSlot = herinvesteringsReserve.waardeSlot;

                      // Check of beide undefined of null zijn
                      if (waardeOpening === undefined && waardeSlot === undefined) {
                          onderneming.beginstandHIR = undefined;

                      } else {
                          const vrijvalHIR = (waardeOpening || 0) - (waardeSlot || 0);

                          if (vrijvalHIR == 0) {
                              onderneming.dotatieHIR = undefined;
                              onderneming.vrijvalHIR = undefined;
                          }

                          // ALLEEN initialiseren als beginstandHIR nog niet bestaat of leeg is
                          if (!onderneming.beginstandHIR || onderneming.beginstandHIR.length === 0) {
                              onderneming.beginstandHIR = [{
                                  omschrijving: 'Beginstand HIR',
                                  bedrag: waardeOpening || 0
                              }];
                          }

                      }
                  } else {
                      if (onderneming.beginstandHIR && onderneming.beginstandHIR.length > 0) {
                          onderneming.beginstandHIR = undefined;
                      }

                  }

                  const egalisatieReserve = onderneming?.eigenVermogen?.find(
                      (item: any) => item.omschrijving === 'egalisatieReserve');
                  if ((egalisatieReserve?.waardeOpening === null && egalisatieReserve?.waardeSlot === null) ||
                      (egalisatieReserve?.waardeOpening === 0 && egalisatieReserve?.waardeSlot === 0)) {
                      onderneming?.dotatieEgalisatiereserve === null && onderneming.vrijvalEgalisatiereserve === null && onderneming?.beginstandEgalisatiereserve;
                  }
              });

              if (!this.isDefAangifte.value) {
                  ondernemingen.forEach(onderneming => {
                      onderneming.agrarischeActiviteiten = false;
                      onderneming.schadeloosstellingBuitenWinstOm = false;
                      onderneming.waarderingsstelselGewijzigd = false;
                      onderneming.willekeurigAfgeschreven = false;
                      onderneming.immaterieleVasteActiva = undefined;
                      onderneming.materieleVasteActiva = undefined;
                      onderneming.financieleVasteActiva = undefined;
                      onderneming.vlottendeActivaVoorraad = undefined;
                      onderneming.vlottendeActivaVorderingen = undefined;
                      onderneming.effecten = undefined;
                      onderneming.liquideMiddelen = undefined;
                      onderneming.eigenVermogen = undefined;
                      onderneming.langlopendeSchulden = undefined;
                      onderneming.kortlopendeSchulden = undefined;
                  });
              }
          }
        }
        if (oudedagsreserveBeginJaar > 0 && wuo) {
          wuo.oudedagsreserveBeginJaar = oudedagsreserveBeginJaar;
        } else {
          wuo.oudedagsreserveBeginJaar = undefined;
        }
        if (!wuo?.krijgtZelfstandigenAftrek) {
          wuo.krijgtStartersAftrek = undefined;
          wuo.meewerkUren = undefined;
          wuo.krijgtSenOaftrek = undefined;
          wuo.krijgtVerhogingSenOAftrek = undefined;
          wuo.speurOntwikkelaarVerklaringNummer = undefined;
        }
      }


      if (aangifte.partnerAangifte?.box1?.winstUitOnderneming != undefined) {
        const wuo = aangifte?.partnerAangifte?.box1?.winstUitOnderneming;
        let oudedagsreserveBeginJaar = 0;
        if (wuo) {
          const ondernemingen = wuo?.ondernemingen;
          if (Array.isArray(ondernemingen) && ondernemingen.length === 0) {
            if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.winstUitOnderneming)
              aangifte.partnerAangifte.box1.winstUitOnderneming.krijgtZelfstandigenAftrek = undefined;
            aangifte.partnerAangifte.box1.winstUitOnderneming.krijgtStartersAftrek = undefined;
            aangifte.partnerAangifte.box1.winstUitOnderneming.krijgtSenOaftrek = undefined;
            aangifte.partnerAangifte.box1.winstUitOnderneming.krijgtVerhogingSenOAftrek = undefined;
            aangifte.partnerAangifte.box1.winstUitOnderneming.meewerkUren = undefined;
          }
          if (Array.isArray(ondernemingen) && ondernemingen.length > 0) {
            this.heeftPartnerWuo.next(true);
            ondernemingen[0].agrarischeActiviteiten = ondernemingen[0].agrarischeActiviteiten ?? undefined;

            if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK) {
              ondernemingen[0].resultaatSamenwerking = undefined;
              ondernemingen[0].invullenOpPersoonlijkNiveau = undefined;
              ondernemingen[0].invullenOpNiveauSamenwerkingsverband = undefined;
              ondernemingen[0].invullenOpJaaropgaveCV = undefined;
              ondernemingen[0].rsin = undefined;
            }

            this.heeftSamenwerkingsverbandWuoPartner.next(false);
            this.heeftEenmanszaakWuoPartner.next(false);
            if (ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK) {
              if (ondernemingen[0].invullenOpNiveauSamenwerkingsverband) {
                ondernemingen[0].invullenOpPersoonlijkNiveau = false;
                this.heeftSamenwerkingsverbandWuoPartner.next(true);
                if (ondernemingen[0].resultaatSamenwerking) {
                  ondernemingen[0].resultaatSamenwerking.aandeelBelastingplichtigeInKapitaalOverig = 0;
                  if (ondernemingen[0].resultaatSamenwerking.vergoedingVoorArbeidBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.vergoedingVoorArbeidBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.vergoedingVoorArbeidBelastingplichtige = 0;
                  }
                  if (ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.aandeelRestantWinstBelastingplichtige = 0;
                  }
                  if (ondernemingen[0].resultaatSamenwerking.overigeVergoedingenBelastingplichtige === undefined ||
                    ondernemingen[0].resultaatSamenwerking.overigeVergoedingenBelastingplichtige === null) {
                    ondernemingen[0].resultaatSamenwerking.overigeVergoedingenBelastingplichtige = 0;
                  }
                }
              } else {
                ondernemingen[0].invullenOpPersoonlijkNiveau = true;
                this.heeftSamenwerkingsverbandWuoPartner.next(false);
              }
            } else if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK) {
              this.heeftEenmanszaakWuoPartner.next(true);
            }

            if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK ||
              ondernemingen[0].invullenOpPersoonlijkNiveau
            ) {
              ondernemingen[0].resultaatSamenwerking = undefined;
            }

            if (ondernemingen[0].investeringen && Array.isArray(ondernemingen[0].investeringen)) {
              ondernemingen[0].investeringen.forEach(investering => {
                if (investering.investeringsbedragKIA === undefined) {
                  investering.claimKIA = undefined;
                }
                if (investering.investeringsbedragEIA === undefined) {
                  investering.claimEIA = undefined;
                }
                if (investering.investeringsbedragMIA === undefined) {
                  investering.claimMIA = undefined;
                }
                if (ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.EENMANSZAAK ||
                  ((ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.VOF || ondernemingen[0].ondernemingsvorm === Ondernemingsvorm.MAATSCHAP)
                    && !ondernemingen[0].invullenOpNiveauSamenwerkingsverband)
                ) {
                  if (investering.investeringsbedragKIA !== undefined) {
                    investering.aandeelInInvesteringsBedrag = investering.investeringsbedragKIA;
                  }
                }
              });
            }
          }
          ondernemingen.forEach(onderneming => {
            ['financieleBaten', 'buitengewoneBaten', 'financieleLasten', 'buitengewoneLasten'].forEach(key => {
              if (onderneming[key]) {
                onderneming[key] = onderneming[key].map((item: Onderneming) => (item === null ? undefined : item));
              }
            });

            if (onderneming.werkzaamheden) {
              let werkzaamheden = this.sanitizeText(onderneming.werkzaamheden);
              werkzaamheden = werkzaamheden.substring(0, 70);
              onderneming.werkzaamheden = werkzaamheden;
            }

            if (onderneming.naam) {
              onderneming.naam = this.sanitizeText(onderneming.naam);
            }

            if (onderneming.schadeloosstellingBuitenWinstOm === false) {
              onderneming.schadeloosstellingBuitenWinst = undefined;
            }

            onderneming.materieleVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null);
            onderneming.immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null);
            onderneming.vlottendeActivaVoorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null);
            onderneming.vlottendeActivaVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null);
            onderneming.financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null);
            onderneming.liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null);
            onderneming.effecten = onderneming?.effecten?.filter(item => item !== null);

            onderneming.eigenVermogen = onderneming?.eigenVermogen?.filter(item => item !== null);
            onderneming.eigenVermogen = onderneming?.eigenVermogen?.filter(
              item => item !== null && !item.omschrijving?.includes('fiscaalOndernemingsVermogen')
            );
            onderneming.voorzieningen = onderneming?.voorzieningen?.filter(item => item !== null);
            onderneming.langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null);
            onderneming.kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null);

            onderneming.wuoOpbrengsten = onderneming?.wuoOpbrengsten?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.wuoStakingswinsten = onderneming?.wuoStakingswinsten?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.wuoVrijgesteldeWinstbestanddelen = onderneming?.wuoVrijgesteldeWinstbestanddelen?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.financieleBaten = onderneming?.financieleBaten?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.financieleLasten = onderneming?.financieleLasten?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.buitengewoneBaten = onderneming?.buitengewoneBaten?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.buitengewoneLasten = onderneming?.buitengewoneLasten?.filter(kosten => kosten && kosten.bedrag !== undefined);

            onderneming.wuoKosten = onderneming?.wuoKosten?.filter(kosten => kosten && kosten.bedrag !== undefined);
            onderneming.wuoKosten = onderneming?.wuoKosten?.filter(kosten => kosten && kosten.bedrag !== null);

            onderneming.investeringen = onderneming?.investeringen?.filter(item => item !== null);
            onderneming.restantInvesteringsaftrek = onderneming?.restantInvesteringsaftrek?.filter(item => item !== null);

            onderneming.onttrekkingenOverig = onderneming?.onttrekkingenOverig?.filter(item => item !== null);
            onderneming.onttrekkingOG = onderneming?.onttrekkingOG?.filter(item => item !== null);
            onderneming.onttrekkingPriveGebruikAuto = onderneming?.onttrekkingPriveGebruikAuto?.filter(item => item !== null);
            onderneming.onttrekkingPriveGebruikWoning = onderneming?.onttrekkingPriveGebruikWoning?.filter(item => item !== null);

            if (onderneming.onttrekkingOG != null) {
              onderneming.onttrekkingOG.forEach(item => {
                if (!item.taxateurBetrokken) item.naamTaxateur = undefined;
              });
            }

            onderneming.stortingenOverig = onderneming?.stortingenOverig?.filter(item => item !== null);
            onderneming.stortingOG = onderneming?.stortingOG?.filter(item => item !== null);

            onderneming.nietAftrekbareKosten = onderneming?.nietAftrekbareKosten?.filter(item => item !== null);
            onderneming.beperktAftrekbareKosten = onderneming?.beperktAftrekbareKosten?.filter(item => item !== null);

            if (onderneming.datumStaking === null && onderneming.staking !== undefined) {
              onderneming.staking = undefined;
            }
            if (onderneming.datumStaking === null && onderneming.wuoStakingswinsten !== undefined) {
              onderneming.wuoStakingswinsten = undefined;
            }

            const eigenVermogen = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'eigenVermogen');
            if (eigenVermogen) {
              eigenVermogen.waardeSlot = this.berekenEigenVermogenSlot(onderneming);
              eigenVermogen.waardeOpening = this.berekenEigenVermogenOpening(onderneming);
            }

            const oudedagsReserve = onderneming?.eigenVermogen?.find(
              (item: JaarrekeningBalans) => item?.omschrijving === 'oudedagsReserve');
            if (oudedagsReserve) {
              const waardeOpening = oudedagsReserve.waardeOpening || 0;
              const waardeSlot = oudedagsReserve.waardeSlot || 0;
              onderneming.beginstandFOR = waardeOpening;
              const vrijvalFOR = waardeOpening - waardeSlot;
              if (vrijvalFOR > 0) {
                onderneming.vrijvalFOR = vrijvalFOR;
              } else {
                onderneming.vrijvalFOR = undefined;
              }
              oudedagsreserveBeginJaar += waardeOpening;
            }

            const herinvesteringsReserve = onderneming?.eigenVermogen?.find(
              (item: any) => item.omschrijving === 'herinvesteringsReserve');

            if (herinvesteringsReserve) {
              const waardeOpening = herinvesteringsReserve.waardeOpening;
              const waardeSlot = herinvesteringsReserve.waardeSlot;

              // Check of beide undefined of null zijn
              if (waardeOpening === undefined && waardeSlot === undefined) {
                onderneming.beginstandHIR = undefined;
              } else {
                const vrijvalHIR = (waardeOpening || 0) - (waardeSlot || 0);

                if (vrijvalHIR == 0) {
                  onderneming.dotatieHIR = undefined;
                  onderneming.vrijvalHIR = undefined;
                }

                // ALLEEN initialiseren als beginstandHIR nog niet bestaat of leeg is
                if (!onderneming.beginstandHIR || onderneming.beginstandHIR.length === 0) {
                  onderneming.beginstandHIR = [{
                    omschrijving: 'Beginstand HIR',
                    bedrag: waardeOpening || 0
                  }];
                }

              }
            } else {
              if (onderneming.beginstandHIR && onderneming.beginstandHIR.length > 0) {
                onderneming.beginstandHIR = undefined;
              }

            }

            const egalisatieReserve = onderneming?.eigenVermogen?.find(
              (item: JaarrekeningBalans) => item?.omschrijving === 'egalisatieReserve');
            if (egalisatieReserve?.waardeOpening === null && egalisatieReserve?.waardeSlot === null) {
              onderneming?.dotatieEgalisatiereserve === null && onderneming.vrijvalEgalisatiereserve === null && onderneming?.beginstandEgalisatiereserve;
            }
          });


          if (!this.isDefAangifte.value) {
            ondernemingen.forEach(onderneming => {
              onderneming.agrarischeActiviteiten = false;
              onderneming.schadeloosstellingBuitenWinstOm = false;
              onderneming.waarderingsstelselGewijzigd = false;
              onderneming.willekeurigAfgeschreven = false;
              onderneming.immaterieleVasteActiva = undefined;
              onderneming.materieleVasteActiva = undefined;
              onderneming.financieleVasteActiva = undefined;
              onderneming.vlottendeActivaVoorraad = undefined;
              onderneming.vlottendeActivaVorderingen = undefined;
              onderneming.effecten = undefined;
              onderneming.liquideMiddelen = undefined;
              onderneming.eigenVermogen = undefined;
              onderneming.langlopendeSchulden = undefined;
              onderneming.kortlopendeSchulden = undefined;
            });
          }
        }
        if (oudedagsreserveBeginJaar > 0 && wuo) {
          wuo.oudedagsreserveBeginJaar = oudedagsreserveBeginJaar;
        } else {
          wuo.oudedagsreserveBeginJaar = undefined
          ;
        }
        if (!wuo?.krijgtZelfstandigenAftrek) {
          wuo.krijgtStartersAftrek = undefined
          wuo.meewerkUren = undefined;
          wuo.krijgtSenOaftrek = undefined;
          wuo.krijgtVerhogingSenOAftrek = undefined;
          wuo.speurOntwikkelaarVerklaringNummer = undefined;
        }
          if (wuo.krijgtZelfstandigenAftrek && wuo.krijgtStartersAftrek) {
              wuo.krijgtStartersAftrekBijArbeidsOngeschiktheid = undefined;
          }

      }

      // loon
      if (aangifte.box1 && aangifte.box1.belastbaarLoon && (aangifte.box1.belastbaarLoon.dubbelePositie || !aangifte.box1.belastbaarLoon.dubbelePositie)) {
        if (aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking === undefined && aangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking === undefined) {
          aangifte.box1.belastbaarLoon.dubbelePositie = undefined;
        }
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon && aangifte.partnerAangifte.box1.belastbaarLoon.dubbelePositie !== undefined) {
        if (aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking === undefined && aangifte.partnerAangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking === undefined) {
          aangifte.partnerAangifte.box1.belastbaarLoon.dubbelePositie = undefined;
        }
      }

      //loon buitenland
      if (aangifte.box1?.belastbaarLoon?.loonUitBuitenlandseDienstbetrekkingOfPensioen?.length) {
        const loonUitBuitenlandseDienstbetrekkingOfPensioen = aangifte.box1?.belastbaarLoon?.loonUitBuitenlandseDienstbetrekkingOfPensioen;
        for (const buitenlandLoon of loonUitBuitenlandseDienstbetrekkingOfPensioen) {
          const {inkomenZitInNederlandseGrondslag, belastDeelLoonInNederland} = buitenlandLoon || {};
          if (!inkomenZitInNederlandseGrondslag && belastDeelLoonInNederland > 0) {
            buitenlandLoon.belastDeelLoonInNederland = 0;
          }
        }
      }
      if (aangifte.partnerAangifte?.box1?.belastbaarLoon?.loonUitBuitenlandseDienstbetrekkingOfPensioen?.length) {
        const loonUitBuitenlandseDienstbetrekkingOfPensioen = aangifte.partnerAangifte?.box1.belastbaarLoon?.loonUitBuitenlandseDienstbetrekkingOfPensioen;
        for (const buitenlandLoon of loonUitBuitenlandseDienstbetrekkingOfPensioen) {
          const {inkomenZitInNederlandseGrondslag, belastDeelLoonInNederland} = buitenlandLoon || {};
          if (!inkomenZitInNederlandseGrondslag && belastDeelLoonInNederland > 0) {
            buitenlandLoon.belastDeelLoonInNederland = 0;
          }
        }
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon && aangifte.partnerAangifte.box1.belastbaarLoon.dubbelePositie !== undefined) {
        if (aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking === undefined && aangifte.partnerAangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking === undefined) {
          aangifte.partnerAangifte.box1.belastbaarLoon.dubbelePositie = undefined;
        }
      }

      let aangeverCount = 0;
      let partnerCount = 0;
      const getLength = (path: any): number => path?.length || 0;
      this.heeftLoonMeerdere.next(false);
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon && aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking) {
        partnerCount += getLength(aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitTegenwoordigeDienstbetrekking);
        if (partnerCount >= 2) {
          this.heeftLoonMeerdere.next(true);
        }
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon && aangifte.partnerAangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking) {
        partnerCount += getLength(aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking);
        if (partnerCount >= 2) {
          this.heeftLoonMeerdere.next(true);
        }
      }
      if (aangifte.box1 && aangifte.box1.belastbaarLoon && aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking) {
        aangeverCount += getLength(aangifte?.box1?.belastbaarLoon?.loonUitTegenwoordigeDienstbetrekking);
        if (aangeverCount >= 2) {
          this.heeftLoonMeerdere.next(true);
        }
      }
      if (aangifte.box1 && aangifte.box1.belastbaarLoon && aangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking) {
        aangeverCount += getLength(aangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking);
        if (aangeverCount >= 2) {
          this.heeftLoonMeerdere.next(true);
        }
      }
      if (partnerCount < 2 && aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon) {
        if (partnerCount == 1) {
          aangifte.partnerAangifte.box1.belastbaarLoon.dubbelePositie = false;
        } else {
          aangifte.partnerAangifte.box1.belastbaarLoon.dubbelePositie = undefined;
        }
      }

      if (aangeverCount < 2 && aangifte.box1 && aangifte.box1.belastbaarLoon && aangifte.box1.belastbaarLoon) {
        aangifte.box1.belastbaarLoon.dubbelePositie = false;
      }

      this.heeftLoonAangever.next(false);
      if (aangifte.box1 && aangifte.box1.belastbaarLoon && Object.keys(aangifte.box1.belastbaarLoon).length > 0) {
        this.heeftLoonAangever.next(true);
      }

      this.heeftLoonTegenwoordigAangever.next(false);
      if (aangifte.box1 && aangifte.box1.belastbaarLoon != undefined &&
        aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking != undefined) {
        this.heeftLoonTegenwoordigAangever.next(true);
      }

      if (aangifte.box1 && aangifte.box1.belastbaarLoon != undefined &&
        aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking == undefined &&
        aangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking == undefined &&
        aangifte.box1.belastbaarLoon.loonUitBuitenlandseDienstbetrekkingOfPensioen == undefined &&
        aangifte.box1.belastbaarLoon.vrijgesteldLoonInternationaleOrganisatie == undefined
      ) {
        aangifte.box1.belastbaarLoon = undefined;
      }

      this.heeftLoonPartner.next(false);
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon != undefined &&
        Object.keys(aangifte.partnerAangifte.box1.belastbaarLoon).length > 0) {
        this.heeftLoonPartner.next(true);
      }

      this.heeftLoonTegenwoordigPartner.next(false);
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon != undefined &&
        aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking != undefined) {
        this.heeftLoonTegenwoordigPartner.next(true);
      }

      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 && aangifte.partnerAangifte.box1.belastbaarLoon != undefined &&
        aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking == undefined &&
        aangifte.partnerAangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking == undefined &&
        aangifte.partnerAangifte.box1.belastbaarLoon.loonUitBuitenlandseDienstbetrekkingOfPensioen == undefined &&
        aangifte.partnerAangifte.box1.belastbaarLoon.vrijgesteldLoonInternationaleOrganisatie == undefined
      ) {
        aangifte.partnerAangifte.box1.belastbaarLoon = undefined;
      }

      // row
      if (aangifte.box1 && aangifte.box1?.resultaatUitOverigeWerkzaamheden && Object.keys(aangifte.box1?.resultaatUitOverigeWerkzaamheden).length === 0) {
        aangifte.box1.resultaatUitOverigeWerkzaamheden = undefined;
      }
      this.heeftOverigInkomen.next(false);
      if (aangifte.box1 &&
        ((aangifte.box1.resultaatUitOverigeWerkzaamheden != undefined && Object.keys(aangifte.box1.resultaatUitOverigeWerkzaamheden).length > 0)
          || (aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen != undefined && Object.keys(aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen).length > 0 &&
                aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen != undefined || aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen != undefined))) {
        this.heeftOverigInkomen.next(true);
      }
      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box1 &&
        ((aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden != undefined && Object.keys(aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden).length > 0) ||
            (aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen != undefined && Object.keys(aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen).length > 0 &&
            aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen != undefined || aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen != undefined))) {
        this.heeftOverigInkomen.next(true);
      }


      // woning
      if (aangifte.box1?.belastbareInkomstenUitEigenWoning !== undefined) {
        const woningen = aangifte?.box1?.belastbareInkomstenUitEigenWoning?.eigenWoningen;
        if (woningen && Array.isArray(woningen)) {
          if (woningen.length === 0) {
            aangifte.box1.belastbareInkomstenUitEigenWoning = undefined;
          }
          woningen.forEach(woning => {
            if (woning.leegstand?.length === 0) {
              woning.leegstand = undefined;
            }
          });
        }
      }

      if (aangifte.box1 && aangifte.box1.belastbareInkomstenUitEigenWoning) {
        if (Object.keys(aangifte.box1.belastbareInkomstenUitEigenWoning).length === 0) {
          aangifte.box1.belastbareInkomstenUitEigenWoning = undefined;
        }
      }
      this.heeftEigenWoning.next(false);
      if (aangifte.box1 && aangifte.box1.belastbareInkomstenUitEigenWoning != undefined && Object.keys(aangifte.box1.belastbareInkomstenUitEigenWoning).length > 0) {
        this.heeftEigenWoning.next(true);
      }
      // premies ink voorz
      this.heeftPremiesInkomensvoorzieningenAangever.next(false);
      if (aangifte.box1 &&
        (aangifte.box1.uitgavenVoorInkomensvoorzieningen != undefined && Object.keys(aangifte.box1.uitgavenVoorInkomensvoorzieningen).length > 0) ||
        (aangifte.box1?.negatieveUitgavenVoorInkomensvoorzieningen != undefined && Object.keys(aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen).length > 0)
      ) {
        this.heeftPremiesInkomensvoorzieningenAangever.next(true);
      }

      this.heeftPremiesInkomensvoorzieningenPartner.next(false);
      if (aangifte.partnerAangifte && aangifte.partnerAangifte?.box1 &&
        (aangifte.partnerAangifte?.box1.uitgavenVoorInkomensvoorzieningen != undefined && Object.keys(aangifte.partnerAangifte.box1.uitgavenVoorInkomensvoorzieningen).length > 0) ||
        (aangifte.partnerAangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen != undefined && Object.keys(aangifte.partnerAangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen).length > 0)) {
        this.heeftPremiesInkomensvoorzieningenPartner.next(true);
      }

      if (aangifte.box1 && aangifte.box1.uitgavenVoorInkomensvoorzieningen && Object.keys(aangifte.box1.uitgavenVoorInkomensvoorzieningen).length === 0) {
        aangifte.box1.uitgavenVoorInkomensvoorzieningen = undefined;
      }

      // box 2
      if (aangifte.box2) {
        if (Object.keys(aangifte.box2).length === 0) {
          aangifte.box2 = undefined;
        }
      }

      if (aangifte.partnerAangifte && aangifte.partnerAangifte.box2) {
          aangifte.partnerAangifte.box2 = undefined;
      }

      this.heeftBox2.next(false);
      if (aangifte.box2 != undefined && Object.keys(aangifte.box2).length > 0) {
        this.heeftBox2.next(true);
      }

      // box 3 - onr zaken
      if (aangifte.box3 &&
        Object.keys(aangifte.box3).length === 0) {
        aangifte.box3 = undefined;
      }

      if (aangifte.box3 && Object.keys(aangifte.box3).length > 0) {
        if (aangifte.aangifteJaar != 2025) {
            this.fixOwr(aangifte);
        }
        // if (aangifte.box3?.overigeOnroerendeZaken?.length) {
        //   const onroerendeZakenArray = aangifte.box3.overigeOnroerendeZaken; // Nieuwe naam voor de array
        //   for (const onroerendGoed of onroerendeZakenArray) { // Andere naam voor de iterator
        //     if (onroerendGoed) {
        //       if (onroerendGoed.verhuurdOfVerpacht && onroerendGoed.verhuurdOfVerpacht.huurbescherming != null && !onroerendGoed.verhuurdOfVerpacht.huurbescherming) {
        //         onroerendGoed.verhuurdOfVerpacht['jaarhuur'] = undefined;
        //         onroerendGoed.verhuurdOfVerpacht['jaarpacht'] = undefined;
        //         onroerendGoed.verhuurdOfVerpacht['onzakelijkeHuur'] = false;
        //         onroerendGoed.verhuurdOfVerpacht['zelfstandigDeelVanGroterGebouw'] = false;
        //       }
        //       if (onroerendGoed.verhuurdOfVerpachtOpEinddatum && onroerendGoed.verhuurdOfVerpachtOpEinddatum.huurbescherming != null && !onroerendGoed.verhuurdOfVerpachtOpEinddatum.huurbescherming) {
        //         onroerendGoed.verhuurdOfVerpachtOpEinddatum['jaarhuur'] = undefined;
        //         onroerendGoed.verhuurdOfVerpachtOpEinddatum['jaarpacht'] = undefined;
        //         onroerendGoed.verhuurdOfVerpachtOpEinddatum['onzakelijkeHuur'] = false;
        //         onroerendGoed.verhuurdOfVerpachtOpEinddatum['zelfstandigDeelVanGroterGebouw'] = false;
        //       }
        //         if (onroerendGoed.verhuurdOfVerpacht && onroerendGoed.verhuurdOfVerpacht.onzakelijkeHuur != null && onroerendGoed.verhuurdOfVerpacht.onzakelijkeHuur) {
        //             onroerendGoed.verhuurdOfVerpacht['jaarhuur'] = undefined;
        //             onroerendGoed.verhuurdOfVerpacht['jaarpacht'] = undefined;
        //             onroerendGoed.verhuurdOfVerpacht['percentageVerhuurd'] = 100;
        //         }
        //     }
        //   }
        // }
      }

      if (aangifte.aangifteJaar === 2024) {
        this.vermogensGrensVoorRegelingen = 73904;
      }
      if (aangifte.aangifteJaar === 2025) {
        this.vermogensGrensVoorRegelingen = 74790;
      }
      if (aangifte.aangifteJaar === 2026) {
        this.vermogensGrensVoorRegelingen = 76958;
      }

      this.heeftBox3Samenvatting.next(false);
      if (aangifte.box3 != undefined && Object.keys(aangifte.box3).length > 0) {
        this.heeftBox3Samenvatting.next(true);
      }

      if (aangifte.box3?.overigeOnroerendeZaken && aangifte.box3.overigeOnroerendeZaken.length > 0) {
        aangifte.box3.overigeOnroerendeZaken.forEach((oz: OnroerendeZaak, index: number) => {
          if (oz) {
            const adres = oz.adres;
            if (adres.postcode == '' && adres.landCode != 'NLD') {
                adres.postcode = '1111'
              }
            const postcode = adres?.postcode ?? '1111';
            const huisnr = adres?.huisNummer ?? '2222';
            const woz = oz.woz ?? '3333';

            let woznummerValue = [index, postcode, huisnr, woz].map(String).join('');
            woznummerValue = woznummerValue.replace(/\D/g, '').slice(0, 12).padStart(12, '0');
            oz.woznummer = woznummerValue;
            if (oz.verhuurdOfVerpacht &&
              (oz.verhuurdOfVerpacht.status === undefined)) {
              oz.verhuurdOfVerpacht = undefined;
            }
            if (oz.verhuurdOfVerpacht && oz.verhuurdOfVerpacht.status !== undefined) {
              if (oz.verhuurdOfVerpacht.status === VerhuurdOfVerpachtStatus.VERHUURD) {
                oz.verhuurdOfVerpacht.jaarpacht = undefined;
              }
              if (oz.verhuurdOfVerpacht.status === VerhuurdOfVerpachtStatus.VERPACHT) {
                oz.verhuurdOfVerpacht.jaarhuur = undefined;
              }
            }
          }
        });
      }

      if (aangifte.box3 && aangifte.aangifteJaar < 2025) {
          if (aangifte.box3.berekenWerkelijkRendement) {
              aangifte.box3.berekenWerkelijkRendement = undefined
          }
      }

      // pga
      if (aangifte.persoonsgebondenAftrek !== undefined && aangifte.persoonsgebondenAftrek != null) {

        const pga = aangifte.persoonsgebondenAftrek;
        if (pga.pgaScholingsuitgaven && Object.keys(pga.pgaScholingsuitgaven).length === 0) {
          pga.pgaScholingsuitgaven = undefined;
        }
        if (pga.pgaAftrekbareGiften && Object.keys(pga.pgaAftrekbareGiften).length === 0) {
          pga.pgaAftrekbareGiften = undefined;
        }
          // Verwijder lege regels waarbij zowel omschrijving als bedrag ontbreken
        if (pga.pgaAftrekbareGiften?.gewoneGiften) {
          const giften = pga.pgaAftrekbareGiften;
          giften.gewoneGiften = giften.gewoneGiften!.filter(
            (gift) => !(!gift.omschrijving && !gift.bedrag)
          ) as typeof giften.gewoneGiften;
        }
        if (pga.pgaAftrekbareGiften?.periodiekeGiften) {
              const giften = pga.pgaAftrekbareGiften;
              giften.periodiekeGiften = giften.periodiekeGiften!.filter(
                  (gift) => !(!gift.omschrijving && !gift.bedrag)
              ) as typeof giften.periodiekeGiften;
        }
        if (pga.pgaSpecifiekeZorgkosten && Object.keys(pga.pgaSpecifiekeZorgkosten).length === 0) {
          pga.pgaSpecifiekeZorgkosten = undefined;
        }
        if (pga.restantPgaVoorgaandeJaren && Object.keys(pga.restantPgaVoorgaandeJaren).length === 0) {
          pga.restantPgaVoorgaandeJaren = undefined;
        }
        if (pga.pgaWeekendUitgavenGehandicapteKinderen && Object.keys(pga.pgaWeekendUitgavenGehandicapteKinderen).length === 0) {
          pga.pgaWeekendUitgavenGehandicapteKinderen = undefined;
        }
        if (pga.pgaOnderhoudsverplichtingen && Object.keys(pga.pgaOnderhoudsverplichtingen).length === 0) {
          pga.pgaOnderhoudsverplichtingen = undefined;
        }

        this.heeftPga.next(false);
        if (aangifte.persoonsgebondenAftrek.pgaScholingsuitgaven != undefined || aangifte.persoonsgebondenAftrek.pgaSpecifiekeZorgkosten != undefined ||
          aangifte.persoonsgebondenAftrek.pgaAftrekbareGiften != undefined || aangifte.persoonsgebondenAftrek.restantPgaVoorgaandeJaren != undefined ||
          aangifte.persoonsgebondenAftrek.pgaWeekendUitgavenGehandicapteKinderen != undefined || aangifte.persoonsgebondenAftrek.pgaOnderhoudsverplichtingen != undefined) {
          this.heeftPga.next(true);
        }

        if (aangifte.persoonsgebondenAftrek.pgaOnderhoudsverplichtingen
          && aangifte.persoonsgebondenAftrek.pgaOnderhoudsverplichtingen.length > 0) {
          aangifte.persoonsgebondenAftrek?.pgaOnderhoudsverplichtingen?.forEach(value => {
            if (value.betaaldeAfkoopsom === 0) value.betaaldeAfkoopsom = undefined;
            if (value.periodiekBetaald === 0) value.periodiekBetaald = undefined;
            if (value.verrekeningPensioenrechten === 0) value.verrekeningPensioenrechten = undefined;
            if (value.bijstandEx === 0) value.bijstandEx = undefined;
            if (value.overigeOnderhoudsverplichtingen === 0) value.overigeOnderhoudsverplichtingen = undefined;

            if (value.exPartner && value.exPartner.gegevensAlimentatieGerechtigde != null && value.exPartner.gegevensAlimentatieGerechtigde.bsn != null) {
              value.exPartner.adresAlimentatieGerechtigde = undefined as unknown as Adres
            }
          });
        }

        if (Object.keys(aangifte.persoonsgebondenAftrek).length === 0) {
          aangifte.persoonsgebondenAftrek = undefined;
        }
      }


      if (aangifte.partnerAangifte && aangifte.partnerAangifte.persoonsgebondenAftrek != undefined) {
        aangifte.partnerAangifte.persoonsgebondenAftrek = undefined
      }

      // voorheffingen
      if (aangifte.voorheffingen && aangifte.voorheffingen.buitenlandseBronheffing) {
        aangifte.voorheffingen.buitenlandseBronheffing.forEach(bron => {
          if (bron.buitenlandsDividendbox2 === 0 && bron.bronbelastingOpDividendbox2 === undefined) {
            bron.buitenlandsDividendbox2 = undefined;
          }
          if (bron.buitenlandsDividendbox2 === undefined && bron.bronbelastingOpDividendbox2 === 0) {
            bron.bronbelastingOpDividendbox2 = 0;
          }
          if (bron.buitenlandsDividendbox3 === 0 && bron.bronbelastingOpDividendbox3 === undefined) {
            bron.buitenlandsDividendbox3 = undefined;
          }
          if (bron.buitenlandsDividendbox3 === undefined && bron.bronbelastingOpDividendbox3 === 0) {
            bron.bronbelastingOpDividendbox3 = 0;
          }
        });
      }

      if (aangifte.premieplicht != null) {
          if (aangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW !== null) {
              if (aangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW?.begindatum === undefined && aangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW?.einddatum === undefined )
                  aangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW = undefined
          }
          if (aangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ !== null) {
              if (aangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ?.begindatum === undefined && aangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ?.einddatum === undefined )
                  aangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ = undefined
          }
      }

        if (aangifte.partnerAangifte && aangifte.partnerAangifte.premieplicht != null) {
            if (aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW !== null) {
                if (aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW?.begindatum === undefined && aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW?.einddatum === undefined )
                    aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorAOWenANW = undefined
            }
            if (aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ !== null) {
                if (aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ?.begindatum === undefined && aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ?.einddatum === undefined )
                    aangifte.partnerAangifte.premieplicht.periodeNietVerzekerdVoorWLZenWVZ = undefined
            }
        }

      // verdeling
      if (aangifte.verdeling != undefined) {

        if (aangifte.aangever! && aangifte.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.ALLEENSTAAND ||
          (aangifte?.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND &&
            aangifte?.aangever.samenwoonSituatie === AangeverSamenwoonSituatie.GEEN)) {
          aangifte.verdeling = undefined;
        }

        if (aangifte.box1?.belastbareInkomstenUitEigenWoning) {
          if (Object.keys(aangifte.box1.belastbareInkomstenUitEigenWoning).length === 0) {
            const verdeling = aangifte.verdeling;
            const verdelingPartner = aangifte.partnerAangifte;
            if (verdeling && verdeling.aandeelEigenWoning != undefined) {
              verdeling.aandeelEigenWoning = undefined;
            }
            if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelEigenWoning != undefined) {
              verdelingPartner.verdeling.aandeelEigenWoning = undefined;
            }
          }
          if (aangifte.partnerAangifte?.box1?.belastbareInkomstenUitEigenWoning) {
            aangifte.partnerAangifte.box1.belastbareInkomstenUitEigenWoning = undefined;
          }
        }

        if (aangifte.box2 && Object.keys(aangifte.box2).length === 0) {
          aangifte.box2 = undefined;
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelBox2 != undefined) {
            verdeling.aandeelBox2 = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelBox2 != undefined) {
            verdelingPartner.verdeling.aandeelBox2 = undefined;
          }
        }
        if (aangifte.box3 && Object.keys(aangifte.box3).length === 0) {
          aangifte.box3 = undefined;
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelBox3 != undefined) {
            verdeling.aandeelBox3 = undefined;
            verdeling.aandeelRendementsGrondslag = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelBox3 != undefined) {
            verdelingPartner.verdeling.aandeelBox3 = undefined;
            verdelingPartner.verdeling.aandeelRendementsGrondslag = undefined;
          }
        }

        if (aangifte.verdeling?.aandeelBox3 !== 0 || aangifte.partnerAangifte?.verdeling?.aandeelBox3 != 0) {
          if (aangifte.verdeling) {
            aangifte.verdeling.aandeelRendementsGrondslag = undefined;
          }
          if (aangifte.partnerAangifte && aangifte.partnerAangifte.verdeling) {
            aangifte.partnerAangifte.verdeling.aandeelRendementsGrondslag = undefined;
          }
        }

        if (aangifte.verdeling) {
            if (aangifte.verdeling.aandeelRendementsGrondslag != undefined &&
                aangifte.verdeling.aandeelRendementsGrondslag < 0) {
                aangifte.verdeling.aandeelRendementsGrondslag = 0
            }
            if (aangifte.partnerAangifte && aangifte.partnerAangifte.verdeling &&
                aangifte.partnerAangifte.verdeling.aandeelRendementsGrondslag != undefined &&
                aangifte.partnerAangifte.verdeling.aandeelRendementsGrondslag < 0) {
                aangifte.partnerAangifte.verdeling.aandeelRendementsGrondslag = 0
            }
        }

        if (aangifte.persoonsgebondenAftrek) {
          const pga = aangifte.persoonsgebondenAftrek;
          if (pga && (pga.pgaAftrekbareGiften && Object.keys(pga.pgaAftrekbareGiften).length === 0) &&
            (pga.pgaScholingsuitgaven && Object.keys(pga.pgaScholingsuitgaven).length === 0) &&
            (pga.pgaWeekendUitgavenGehandicapteKinderen && Object.keys(pga.pgaWeekendUitgavenGehandicapteKinderen).length === 0) &&
            (pga.pgaSpecifiekeZorgkosten && Object.keys(pga.pgaSpecifiekeZorgkosten).length === 0)) {
            aangifte.persoonsgebondenAftrek = undefined;
            const verdeling = aangifte.verdeling;
            const verdelingPartner = aangifte.partnerAangifte;
            if (verdeling && verdeling.aandeelPGA != undefined) {
              verdeling.aandeelPGA = undefined;
            }
            if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelPGA != undefined) {
              verdelingPartner.verdeling.aandeelPGA = undefined;
            }
          }
        }
        if ((aangifte.voorheffingen && Object.keys(aangifte.voorheffingen).length === 0) ||
          aangifte.voorheffingen?.ingehoudenDividendbelasting && Object.keys(aangifte.voorheffingen?.ingehoudenDividendbelasting).length === 0) {
          aangifte.voorheffingen.ingehoudenDividendbelasting = undefined;
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelDividendbelasting != undefined) {
            verdeling.aandeelDividendbelasting = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelDividendbelasting != undefined) {
            verdelingPartner.verdeling.aandeelDividendbelasting = undefined;
          }
        }

        if (aangifte.box1 === undefined || (aangifte.box1 && aangifte.box1.belastbareInkomstenUitEigenWoning == undefined)) {
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelEigenWoning != undefined) {
            verdeling.aandeelEigenWoning = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelEigenWoning != undefined) {
            verdelingPartner.verdeling.aandeelEigenWoning = undefined;
          }
        }
        if (aangifte.box2 === undefined || (aangifte.box2 && aangifte.box2?.aanmerkelijkBelang == undefined)) {

          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelBox2 != undefined) {
            verdeling.aandeelBox2 = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelBox2 != undefined) {
            verdelingPartner.verdeling.aandeelBox2 = undefined;
          }
        }
        if (aangifte.box3 === undefined) {
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelBox3 != undefined) {
            verdeling.aandeelBox3 = undefined;
          }
          if (verdeling && verdeling.aandeelRendementsGrondslag != undefined) {
            verdeling.aandeelRendementsGrondslag = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelBox3 != undefined) {
            verdelingPartner.verdeling.aandeelBox3 = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelRendementsGrondslag != undefined) {
            verdelingPartner.verdeling.aandeelRendementsGrondslag = undefined;
          }
        }
        if (aangifte.persoonsgebondenAftrek === undefined) {
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelPGA != undefined) {
            verdeling.aandeelPGA = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelPGA != undefined) {
            verdelingPartner.verdeling.aandeelPGA = undefined;
          }
        }
        if (aangifte.voorheffingen === undefined || aangifte.voorheffingen.ingehoudenDividendbelasting === undefined) {
          const verdeling = aangifte.verdeling;
          const verdelingPartner = aangifte.partnerAangifte;
          if (verdeling && verdeling.aandeelDividendbelasting != undefined) {
            verdeling.aandeelDividendbelasting = undefined;
          }
          if (verdeling && verdelingPartner?.verdeling && verdelingPartner.verdeling.aandeelDividendbelasting != undefined) {
            verdelingPartner.verdeling.aandeelDividendbelasting = undefined;
          }
        }
        if (aangifte.verdeling && Object.keys(aangifte.verdeling).length === 0) {
          aangifte.verdeling = undefined;
          if (aangifte.partnerAangifte) {
            aangifte.partnerAangifte!.verdeling = undefined;
          }
        }
      }

      this.updateMenuInterface(aangifte);
      this.incomeTaxEntity.next(incomeTaxEntity);
    }
  }

  updateControleResponse(controleResponse: Bevinding[]) {
    this.controleResponse.next(controleResponse);
  }

  updateVerzoek(isVerzoek: boolean) {
    this.isVerzoek.next(isVerzoek);
  }

  updateErrorResponse(errorResponse: ErrorMessage[]) {
    this.errorResponse.next(errorResponse);
  }

  updateAantalValidaties(aantalValidaties: number) {
    this.aantalValidaties.next(aantalValidaties);
  }

  updateAantalBevindingen(aantalBevindingen: number) {
    this.aantalBevindingen.next(aantalBevindingen);
  }

  updateDrempelZorgkosten(drempelWaarde: number) {
    this.drempelZorgkosten.next(drempelWaarde);
  }

  updateDrempelGiften(drempelWaarde: number) {
    this.drempelGiften.next(drempelWaarde);
  }

  updateUitleg(uitlegResponse: UitlegResponse) {
    this.uitlegResponse.next(uitlegResponse);
  }

  updateMenuInterface(aangifte: Aangifte) {
    const menuInterface: MenuInterface[] = [
      {
        value: 100,
        id: '',
        label: 'Persoonlijk',
        visible: true,
        subonderdelen: [
          {
            label: 'Aangever',
            pageMapping: 'Aangever',
            visible: true,
            value: 101
          },
          {
            label: 'Wijziging burgerlijke staat',
            pageMapping: 'Wijziging burgerlijke staat',
            visible: aangifte.aangever.burgerlijkeStaat === 'SITUATIE_GEWIJZIGD',
            value: 102
          },
          {
            label: 'Partner',
            pageMapping: 'Partner',
            visible: aangifte.aangever.burgerlijkeStaat === 'GEHUWD' ||
              (aangifte.aangever.burgerlijkeStaat === 'SAMENWONEND' && aangifte.aangever.samenwoonSituatie !== 'GEEN') ||
              (aangifte.aangever.burgerlijkeStaat === 'SITUATIE_GEWIJZIGD' &&
                aangifte.aangever.relatiegegevens !== undefined &&
                aangifte.aangever.relatiegegevens.length > 0 &&
                aangifte.aangever.relatiegegevens[0].voldaanAanFiscaalPartnerschapVoorwaarden === true && aangifte.aangever.relatiegegevens[0].kiestVoorHeleJaarPartnerschap === true),
            value: 103
          },
          {
            label: 'Kinderen',
            pageMapping: 'Kinderen',
            visible: true,
            value: 104
          },
          {
            label: 'VIA inlezen',
            pageMapping: 'VIA inlezen',
            visible: aangifte.biljetSoort !== 'C',
            value: 105
          }
        ]
      },
      {
        value: 200,
        id: '',
        label: 'Winst uit onderneming',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Onderneming',
            pageMapping: 'Onderneming',
            visible: true,
            value: 210
          },
          {
            label: 'Vragen vooraf',
            pageMapping: 'Vragen vooraf',
            visible: this.heeftAangeverWuo.value || this.heeftPartnerWuo.value,
            value: 211
          },
          {
            label: 'Administratie inlezen',
            pageMapping: 'Administratie inlezen',
            visible: (this.isDefAangifte.value && this.heeftAangeverWuo.value) ||
              (!this.isDefAangifte.value && this.heeftAangeverWuo.value && this.heeftEenmanszaakWuoAangever.value) ||
              (this.isDefAangifte.value && this.heeftPartnerWuo.value) ||
              (!this.isDefAangifte.value && this.heeftPartnerWuo.value && this.heeftEenmanszaakWuoPartner.value),
            value: 212
          },
          {
            label: 'Resultatenrekening',
            pageMapping: 'Resultatenrekening',
            visible: (this.isDefAangifte.value && this.heeftAangeverWuo.value) ||
              (!this.isDefAangifte.value && this.heeftAangeverWuo.value && !this.heeftSamenwerkingsverbandWuoAangever.value) ||
              (this.isDefAangifte.value && this.heeftPartnerWuo.value) ||
              (!this.isDefAangifte.value && this.heeftPartnerWuo.value && !this.heeftSamenwerkingsverbandWuoPartner.value),
            value: 213
          },
          {
            label: 'Balans activa',
            pageMapping: 'Balans activa',
            visible: this.isDefAangifte.value && (this.heeftAangeverWuo.value || this.heeftPartnerWuo.value),
            value: 214
          },
          {
            label: 'Balans passiva',
            pageMapping: 'Balans passiva',
            visible: this.isDefAangifte.value && (this.heeftAangeverWuo.value || this.heeftPartnerWuo.value),
            value: 215
          },
          {
            label: 'Samenwerkingsverband',
            pageMapping: 'Samenwerkingsverband',
            visible: (this.heeftAangeverWuo.value && this.heeftSamenwerkingsverbandWuoAangever.value) ||
              (this.heeftPartnerWuo.value && this.heeftSamenwerkingsverbandWuoPartner.value),
            value: 216
          },
          {
            label: 'Priveonttrekkingen en -stortingen',
            pageMapping: 'Priveonttrekkingen en -stortingen',
            visible: this.isDefAangifte.value && (this.heeftAangeverWuo.value || this.heeftPartnerWuo.value),
            value: 217
          },
          {
            label: 'Vermogensvergelijking',
            pageMapping: 'Vermogensvergelijking',
            visible: this.isDefAangifte.value && (this.heeftAangeverWuo.value || this.heeftPartnerWuo.value),
            value: 218
          },
          {
            label: 'Investeringen',
            pageMapping: 'Investeringen',
            visible: this.isDefAangifte.value && (this.heeftAangeverWuo.value || this.heeftPartnerWuo.value),
            value: 219
          },
          {
            label: 'Winstcorrecties',
            pageMapping: 'Winstcorrecties',
            visible: this.heeftAangeverWuo.value || this.heeftPartnerWuo.value,
            value: 220
          },
          {
            label: 'Ondernemersaftrek',
            pageMapping: 'Ondernemersaftrek',
            visible: this.heeftAangeverWuo.value || this.heeftPartnerWuo.value,
            value: 221
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting winst',
            visible: this.heeftAangeverWuo.value || this.heeftPartnerWuo.value,
            value: 222
          }
        ]
      },
      {
        value: 300,
        id: '',
        label: 'Loon & uitkeringen',
        visible: true,
        subonderdelen: [
          {
            label: 'Inkomsten uit loondienst',
            pageMapping: 'Inkomsten uit loondienst',
            visible: true,
            value: 310
          },
          {
            label: 'Reiskosten openbaar vervoer',
            pageMapping: 'Reiskosten openbaar vervoer',
            visible: this.isDefAangifte.value && (this.heeftLoonTegenwoordigAangever.value || this.heeftLoonTegenwoordigPartner.value) && aangifte.biljetSoort !== 'C',
            value: 320
          },
          {
            label: 'Pensioen en andere uitkeringen',
            pageMapping: 'Pensioen en andere uitkeringen',
            visible: true,
            value: 330
          },
          {
            label: 'Meer banen of uitkeringen tegelijk',
            pageMapping: 'Meer banen of uitkeringen tegelijk',
            visible: !this.isDefAangifte.value && this.heeftLoonMeerdere.value,
            value: 340
          },
          {
            label: 'Buitenlands loon/pensioen',
            pageMapping: 'Buitenlands loon',
            visible: aangifte.biljetSoort !== 'C',
            value: 350
          },
          {
            label: 'Vrijgesteld loon',
            pageMapping: 'Vrijgesteld loon',
            visible: aangifte.biljetSoort !== 'C',
            value: 360
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting loon',
            visible: this.heeftLoonAangever.value || this.heeftLoonPartner.value,
            value: 370
          }
        ]
      },
      {
        value: 400,
        id: '',
        label: 'Overige inkomsten',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Resultaat overige werkzaamheden',
            pageMapping: 'Resultaat uit overige werkzaamheden',
            visible: true,
            value: 410

          },
          {
            label: 'Terbeschikkingstellingsregeling',
            pageMapping: 'Terbeschikkingstellingsregeling',
            visible: true,
            value: 420
          },
          {
            label: 'Alimentatie',
            pageMapping: 'Alimentatie',
            visible: true,
            value: 430
          },
          {
            label: 'Periodieke uitkeringen',
            pageMapping: 'Periodieke uitkeringen',
            visible: true,
            value: 440
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting overige inkomsten',
            visible: this.heeftOverigInkomen.value,
            value: 450
          }
        ]
      },
      {
        value: 500,
        id: '',
        label: 'Eigen woning',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Woningen',
            pageMapping: 'Woningen',
            visible: true,
            value: 510
          },
          {
            label: 'Eigenwoningschulden',
            pageMapping: 'Eigenwoningschulden',
            visible: true,
            value: 520
          },
          {
            label: 'Financieringskosten',
            pageMapping: 'Financieringskosten',
            visible: true,
            value: 530
          },
          {
            label: 'Restschulden',
            pageMapping: 'Restschulden',
            visible: true,
            value: 540
          },
          {
            label: 'Huurinkomsten',
            pageMapping: 'Huurinkomsten',
            visible: true,
            value: 550
          },
          {
            label: 'Overig eigen woning',
            pageMapping: 'Overig eigen woning',
            visible: true,
            value: 560
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting eigen woning',
            visible: this.heeftEigenWoning.value,
            value: 570
          }
        ],
      },
      {
        value: 600,
        id: '',
        label: 'Premies inkomensvoorzieningen',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Premies lijfrente',
            pageMapping: 'Premies lijfrente',
            visible: true,
            value: 610
          },
          {
            label: 'Jaar- en reserveringsruimte',
            pageMapping: 'Jaar- en reserveringsruimte',
            visible: true,
            value: 620
          },
          {
            label: 'Overige premies inkomensvoorzieningen',
            pageMapping: 'Overige premies inkomensvoorzieningen',
            visible: true,
            value: 630
          },
          {
            label: 'Teruggave premies inkomensvoorzieningen',
            pageMapping: 'Teruggave premies inkomensvoorzieningen',
            visible: true,
            value: 640
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting premies inkomensvoorzieningen',
            visible: this.heeftPremiesInkomensvoorzieningenAangever.value || this.heeftPremiesInkomensvoorzieningenPartner.value,
            value: 650
          }

        ],
      },
      {
        value: 700,
        id: '',
        label: 'Aanmerkelijk belang (box 2)',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Inkomen uit aanmerkelijk belang',
            pageMapping: 'Aanmerkelijk belang (box 2)',
            visible: true,
            value: 710
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting aanmerkelijk belang',
            visible: this.heeftBox2.value,
            value: 720
          }
        ]
      },
      {
        value: 800,
        id: '',
        label: 'Vermogen (box 3)',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Werkelijk rendement',
            pageMapping: 'Werkelijk rendement',
            visible: aangifte.biljetSoort !== 'C' && aangifte.aangifteJaar == 2025,
            value: 810
          },
          {
            label: 'Bankrekeningen',
            pageMapping: 'Bankrekeningen',
            visible: aangifte.biljetSoort !== 'C',
            value: 820
          },
          {
            label: 'Beleggingen',
            pageMapping: 'Beleggingen',
            visible: aangifte.biljetSoort !== 'C',
            value: 830
          },
          {
            label: 'Overige onroerende zaken',
            pageMapping: 'Overige onroerende zaken',
            visible: true,
            value: 840
          },
          {
            label: 'Overige bezittingen',
            pageMapping: 'Overige bezittingen',
            visible: aangifte.biljetSoort !== 'C',
            value: 850
          },
          {
            label: 'Schulden',
            pageMapping: 'Schulden',
            visible: true,
            value: 860
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting box 3',
            visible: this.heeftBox3Samenvatting.value,
            value: 870
          }
        ],
      },
      {
        value: 900,
        id: 'pgaaftrekbarekosten',
        label: 'Persoonsgebonden aftrek',
        visible: aangifte.biljetSoort !== 'C',
        subonderdelen: [
          {
            label: 'Specifieke zorgkosten',
            pageMapping: 'Specifieke zorgkosten',
            visible: true,
            value: 910
          },
          {
            label: 'Giften',
            pageMapping: 'Giften',
            visible: true,
            value: 920
          },
          {
            label: 'Scholingsuitgaven',
            pageMapping: 'Scholingsuitgaven',
            visible: true,
            value: 930
          },
          {
            label: 'Onderhoudsverplichtingen',
            pageMapping: 'Onderhoudsverplichtingen',
            visible: true,
            value: 940
          },
          {
            label: 'Weekenduitgaven gehandicapte kinderen',
            pageMapping: 'Weekenduitgaven gehandicapte kinderen',
            visible: true,
            value: 950
          },
          {
            label: 'Restant pga voorgaande jaren',
            pageMapping: 'Restant persoonsgebonden aftrek voorgaande jaren',
            visible: true,
            value: 960
          },
          {
            label: 'Negatieve pga',
            pageMapping: 'Negatieve persoonsgebonden aftrek',
            visible: true,
            value: 970
          },
          {
            label: 'Samenvatting',
            pageMapping: 'Samenvatting persoonsgebonden aftrek',
            visible: this.heeftPga.value,
            value: 980
          }
        ],
      },
      {
        value: 1000,
        id: '',
        label: 'Bijzondere situaties',
        visible: true,
        subonderdelen: [
          {
            label: 'Premieplicht',
            pageMapping: 'Premieplicht',
            visible: true,
            value: 1010
          },
          {
            label: 'Wereldinkomen',
            pageMapping: 'Wereldinkomen',
            visible: aangifte.buitenlandseBelastingplicht?.inwonerLandNonDiscriminatie || false,
            value: 1020
          },
        ]
      },
      {
        value: 1100,
        id: '',
        label: 'Voorheffingen & verliezen',
        visible: true,
        subonderdelen: [
          {
            label: 'Voorlopige aanslagen ib / zvw',
            pageMapping: 'Voorlopige aanslagen',
            visible: true,
            value: 1110
          },
          {
            label: 'Nederlandse dividendbelasting',
            pageMapping: 'Nederlandse dividendbelasting',
            visible: aangifte.biljetSoort !== 'C',
            value: 1120
          },
          {
            label: 'Buitenlandse bronbelasting',
            pageMapping: 'Buitenlandse bronbelasting',
            visible: aangifte.biljetSoort !== 'C',
            value: 1130
          },
          {
            label: 'Loon als onderdeel van winst',
            pageMapping: 'Loon als onderdeel van winst',
            visible: this.heeftAangeverWuo.value || this.heeftPartnerWuo.value || aangifte.biljetSoort !== 'C',
            value: 1140
          },
          {
            label: 'Nog verrekenbaar',
            pageMapping: 'Nog verrekenbaar',
            visible: aangifte.biljetSoort !== 'C',
            value: 1150
          }
        ],
      },
      {
        value: 1200,
        id: '',
        label: this.hasVerdeling ? 'Verdeling & berekeningen' : 'Berekeningen',
        visible: true,
        subonderdelen: [
          {
            label: 'Verdeling',
            pageMapping: 'Verdeling',
            visible: this.hasVerdeling || this.hasVerdelingRendementsGrondslag,
            value: 1210
          },
          {
            label: 'Inkomen box 1',
            pageMapping: 'Overzicht inkomen box 1',
            visible: true,
            value: 1220
          },
          {
            label: 'Inkomen box 2',
            pageMapping: 'Overzicht inkomen box 2',
            visible: this.heeftBox2.value,
            value: 1230
          },
          {
            label: 'Inkomen box 3',
            pageMapping: 'Overzicht inkomen box 3',
            visible: this.heeftBox3.valueOf() || this.hasVerdelingRendementsGrondslag,
            value: 1240
          },
          {
            label: 'Berekening inkomstenbelasting',
            pageMapping: 'Berekening inkomstenbelasting',
            visible: true,
            value: 1250
          },
          {
            label: 'Berekening zorgverzekeringswet',
            pageMapping: 'Berekening zorgverzekeringswet',
            visible: true,
            value: 1260
          }
        ],
      }
    ];
    this.menuInterface.next(menuInterface);
  }

  private sanitizeText(input: string): string {
    if (!input || typeof input !== 'string') return input;
    return input.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
  }

  berekenEigenVermogenSlot(onderneming: Onderneming): number {
    let totaalActiva = 0;
    let totaalPassivaZonderEv = 0;
    if (onderneming) {
      //immateriele vaste activa
      const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill')?.waardeSlot || 0;
      const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva')?.waardeSlot || 0;
      const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen')?.waardeSlot || 0;
      const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties')?.waardeSlot || 0;
      const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva')?.waardeSlot || 0;
      const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva')?.waardeSlot || 0;
      const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk')?.waardeSlot || 0;
      const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad')?.waardeSlot || 0;
      const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren')?.waardeSlot || 0;
      const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering')?.waardeSlot || 0;
      const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen')?.waardeSlot || 0;
      const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten')?.waardeSlot || 0;
      const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen')?.waardeSlot || 0;

      totaalActiva = goodWill + immaterieleVasteActiva + bedrijfsGebouwen + machinesEnInstallaties + andereVasteActiva + financieleVasteActiva + voorraad +
        onderhandenWerk + debiteuren + omzetbelastingVordering + overigeVorderingen + effecten + liquideMiddelen;
      const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve')?.waardeSlot || 0;
      const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'oudedagsReserve')?.waardeSlot || 0;
      const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve')?.waardeSlot || 0;
      const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'garantieVoorziening')?.waardeSlot || 0;
      const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVoorzieningen')?.waardeSlot || 0;
      const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kredietinstellingen')?.waardeSlot || 0;
      const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'langlopendeSchulden')?.waardeSlot || 0;
      const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren')?.waardeSlot || 0;
      const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld')?.waardeSlot || 0;
      const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld')?.waardeSlot || 0;
      const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden')?.waardeSlot || 0;

      totaalPassivaZonderEv = egalisatieReserve + oudedagsreserve + herinvesteringsreserve + garantieVoorziening + overigeVoorzieningen + kredietinstellingen + langlopendeSchulden +
        crediteuren + loonheffingSchuld + omzetbelastingSchuld + kortlopendeSchulden;
      return totaalActiva - totaalPassivaZonderEv;
    }
    return 0;
  }

  berekenEigenVermogenOpening(onderneming: Onderneming): number {
    let totaalActiva = 0;
    let totaalPassivaZonderEv = 0;
    if (onderneming) {
      //immateriele vaste activa
      const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill')?.waardeOpening || 0;
      const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva')?.waardeOpening || 0;
      const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen')?.waardeOpening || 0;
      const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties')?.waardeOpening || 0;
      const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva')?.waardeOpening || 0;
      const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva')?.waardeOpening || 0;
      const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk')?.waardeOpening || 0;
      const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad')?.waardeOpening || 0;
      const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren')?.waardeOpening || 0;
      const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering')?.waardeOpening || 0;
      const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen')?.waardeOpening || 0;
      const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten')?.waardeOpening || 0;
      const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen')?.waardeOpening || 0;

      totaalActiva = goodWill + immaterieleVasteActiva + bedrijfsGebouwen + machinesEnInstallaties + andereVasteActiva + financieleVasteActiva + voorraad +
        onderhandenWerk + debiteuren + omzetbelastingVordering + overigeVorderingen + effecten + liquideMiddelen;

      const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve')?.waardeOpening || 0;
      const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'oudedagsReserve')?.waardeOpening || 0;
      const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve')?.waardeOpening || 0;
      const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'garantieVoorziening')?.waardeOpening || 0;
      const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVoorzieningen')?.waardeOpening || 0;
      const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kredietinstellingen')?.waardeOpening || 0;
      const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'langlopendeSchulden')?.waardeOpening || 0;
      const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren')?.waardeOpening || 0;
      const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld')?.waardeOpening || 0;
      const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld')?.waardeOpening || 0;
      const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden')?.waardeOpening || 0;

      totaalPassivaZonderEv = egalisatieReserve + oudedagsreserve + herinvesteringsreserve + garantieVoorziening + overigeVoorzieningen + kredietinstellingen + langlopendeSchulden +
        crediteuren + loonheffingSchuld + omzetbelastingSchuld + kortlopendeSchulden;
      return totaalActiva - totaalPassivaZonderEv;
    }
    return 0;
  }

  public getUitleg(aangifte: Aangifte) {
    this.ibRekenService.getIncomeTaxUitleg(aangifte).subscribe({
      next: (response) => {
        this.updateUitleg(response);
      }
    });
  }

  public postIncomeTaxEntity(sstRelatieId: string, partner: boolean, incomeTaxEntity: IncomeTaxEntity) {
    if (incomeTaxEntity !== null && incomeTaxEntity.sstRelationId !== null) {
      this.bokkzClient.postIncomeTax(incomeTaxEntity.sstRelationId!, false, partner, false, false, incomeTaxEntity).subscribe({
        next: (response) => {
          if (response && response.aangifte != null) {
            this.updateIncomeTaxEntity(response);
            this.updateMenuInterface(response.aangifte);
            this.getValidation(response);
          }
        },
          error: (err) => {
              console.log(err);
              this.toastService.showErrorMessage(
                  "De gegevens zijn niet opgeslagen. De pagina wordt automatisch vernieuwd en probeer het daarna opnieuw."
              );
              setTimeout(() => window.location.reload(), 3000);
          }
      });
    }
  }

  public postIncomeTaxEntityMetLoonheffing(sstRelatieId: string, partner: boolean, incomeTaxEntity: IncomeTaxEntity) {
    this.ibLoonheffingService.berekenLoonheffing(incomeTaxEntity.aangifte).subscribe({
      next: (aangifteMetLoonheffing) => {
        const incomeTaxEntityVar = incomeTaxEntity;
        incomeTaxEntityVar.aangifte = aangifteMetLoonheffing;
        this.bokkzClient.postIncomeTax(sstRelatieId, false, partner, false, false, incomeTaxEntityVar).subscribe({
          next: (response) => {
            this.updateIncomeTaxEntity(response);
          },
          error: (errorPostIncomeTax) => {
            if (errorPostIncomeTax.message) {
              this.toastService.showErrorMessage(errorPostIncomeTax.message);
            }
          }
        });
      },
      error: (errorLoonHeffing) => {
        if (errorLoonHeffing.message) {
          this.toastService.showErrorMessage(errorLoonHeffing.message);
        }
      }
    });
  }

  public getValidation(entity: IncomeTaxEntity) {
    if (entity.aangifte !== undefined && entity.taxType !== undefined) {
      this.ibRekenService.getIncomeTaxValidation(entity.aangifte, entity.taxType?.includes("VA")).subscribe({
        next: (response) => {
          if (response.verzamelinkomen != null) {
            this.updateAantalValidaties(0);
            this.updateAangifteBerekening(response as AangifteBerekening);
            this.hasVerdeling = false;
            this.hasVerdelingRendementsGrondslag = false;
            if (response.partnerBerekening != undefined) {
              this.updatePartnerAangifteBerekening(response.partnerBerekening as AangifteBerekening);
              this.hasVerdeling = this.calculateHasVerdeling(response);
              this.hasVerdelingRendementsGrondslag = this.bepaalVerdelingRendementsGrondslag(response, entity.aangifte!);
              this.vergelijkOptimaal(entity.aangifte!);
              this.updateMenuInterface(entity.aangifte!);
            } else if (entity.aangifte!.gezamenlijkeAangifte === false) {
              this.hasVerdeling = this.calculateHasVerdeling(response);
              this.hasVerdelingRendementsGrondslag = this.bepaalVerdelingRendementsGrondslag(response, entity.aangifte!);
              if (this.hasVerdeling) {
                this.updateHasVerdelingGezien(false);
              }
              this.updateMenuInterface(entity.aangifte!);
            } else {
              this.hasVerdeling = false;
            }
            if (entity.aangifte!.aangever.geboortedatum) {
              this.getRapport(entity.aangifte!);
            }
          } else {
            if ('HV000028: Unexpected exception during isValid call.' === response as unknown as string) {
              this.errorString = response as unknown as string;
              const error: ErrorMessage[] = [{
                error: 'server.error',
                response: 'HV000028: Unexpected exception during isValid call.'
              }];
              this.updateErrorResponse(error);
              this.updateAantalValidaties(1);
            } else {
              if (entity.aangifte!.aangever.geboortedatum) {
                this.getBerekening(entity.aangifte!);
              }
              this.updateErrorResponse(response as ErrorMessage[]);
              this.updateAantalValidaties(this.errorResponse.getValue().length);
            }
          }
        },
        error: (err) => {
          this.updateAantalValidaties(0);
          this.hasVerdeling = false;
          if (entity.aangifte!.aangever.geboortedatum) {
            this.getBerekening(entity.aangifte!);
          }
        }
        // complete: () => console.log("complete")
      });
    }
  }

  public getBevindingen(aangifte: Aangifte) {
    this.controleRequest.aangifte = aangifte;
    this.ibRekenService.getIncomeTaxBevindingen(this.controleRequest).subscribe({
      next: (response) => {
        if (response.bevindingList !== undefined) {
          this.updateControleResponse(response.bevindingList as Bevinding[]);
          this.updateAantalBevindingen(response.bevindingList.length);
        } else {
          this.updateAantalBevindingen(0);
        }
      },
      error: (err) => {
        this.updateAantalBevindingen(0);
        console.log(err);
      }
      // complete: () => console.log("complete")
    });
  }

  public getBerekening(aangifte: Aangifte) {
    setTimeout(() => {
      if (aangifte.aangever && aangifte.aangever.geboortedatum) {
        this.bokkzClient.getIbBerekening(aangifte).subscribe({
          next: (result) => {
            this.updateAangifteBerekening(result as AangifteBerekening);
            this.getRapport(aangifte);
            if (result.partnerBerekening != undefined) {
              this.updatePartnerAangifteBerekening(result.partnerBerekening as AangifteBerekening);
              this.hasVerdeling = this.calculateHasVerdeling(result);
              this.hasVerdelingRendementsGrondslag = this.bepaalVerdelingRendementsGrondslag(result, aangifte);
              this.vergelijkOptimaal(aangifte);
              this.updateMenuInterface(aangifte);
            } else {
              this.hasVerdeling = false;
            }
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    }, 0);
  }

  vergelijkOptimaal(aangifte: Aangifte) {
    const optimaleBerekening = this.getFromSessionStorage('optimaleBerekening') as AangifteBerekening;
    const aangifteBerekening = this.getFromSessionStorage('aangifteBerekening') as AangifteBerekening;
    let optimaalOptellingPga = 0;
    let optellingPga = 0;
    if (optimaleBerekening == undefined) {
      this.updateHasVerdelingGezien(false);
    }
    if (aangifteBerekening.alBetaaldeDividendbelasting == undefined) {
      aangifteBerekening.alBetaaldeDividendbelasting = 0;
    }
    if (aangifteBerekening.partnerBerekening && aangifteBerekening.partnerBerekening.alBetaaldeDividendbelasting == undefined) {
      aangifteBerekening.partnerBerekening.alBetaaldeDividendbelasting = 0;
    }

    if (aangifteBerekening && aangifteBerekening.opbouwPGA) {
      const pga = aangifteBerekening.opbouwPGA;
      const specifiekeZorgkosten = pga?.specifiekeZorgkosten || 0;
      const aftrekbareGiften = pga?.aftrekbareGiften || 0;
      const scholingsuitgaven = pga?.scholingsuitgaven || 0;
      const restantPgaVoorgaandeJaren = pga?.restantPgaVoorgaandeJaren || 0;
      const onderhoudsverplichtingen = pga?.onderhoudsverplichtingen || 0;
      const weekenduitgaven = pga?.weekenduitgaven || 0;
      optellingPga = specifiekeZorgkosten + aftrekbareGiften + scholingsuitgaven + restantPgaVoorgaandeJaren + onderhoudsverplichtingen + weekenduitgaven;
    }
    if (optimaleBerekening && optimaleBerekening.opbouwPGA) {
      const pga = optimaleBerekening.opbouwPGA;
      const specifiekeZorgkosten = pga?.specifiekeZorgkosten || 0;
      const aftrekbareGiften = pga?.aftrekbareGiften || 0;
      const scholingsuitgaven = pga?.scholingsuitgaven || 0;
      const restantPgaVoorgaandeJaren = pga?.restantPgaVoorgaandeJaren || 0;
      const onderhoudsverplichtingen = pga?.onderhoudsverplichtingen || 0;
      const weekenduitgaven = pga?.weekenduitgaven || 0;
      optimaalOptellingPga = specifiekeZorgkosten + aftrekbareGiften + scholingsuitgaven + restantPgaVoorgaandeJaren + onderhoudsverplichtingen + weekenduitgaven;
    }
    if (aangifteBerekening && aangifteBerekening.partnerBerekening && optimaleBerekening != null && optimaleBerekening.partnerBerekening) {
      if (aangifteBerekening.box1?.opbouwInkomen?.saldoEigenWoning != optimaleBerekening.box1?.opbouwInkomen?.saldoEigenWoning ||
        aangifteBerekening.box2?.opbouwInkomen?.saldoAanmerkelijkBelang != optimaleBerekening.box2?.opbouwInkomen?.saldoAanmerkelijkBelang ||
        aangifteBerekening.box3?.opbouwInkomen?.rendementsGrondslag != optimaleBerekening.box3?.opbouwInkomen?.rendementsGrondslag ||
        aangifteBerekening.box3?.opbouwInkomen?.grondslagSparenEnBeleggen != optimaleBerekening.box3?.opbouwInkomen?.grondslagSparenEnBeleggen ||
        optellingPga != optimaalOptellingPga ||
        aangifteBerekening.alBetaaldeDividendbelasting != optimaleBerekening.alBetaaldeDividendbelasting ||
        aangifteBerekening.partnerBerekening?.alBetaaldeDividendbelasting != optimaleBerekening.partnerBerekening?.alBetaaldeDividendbelasting
      ) {
        this.updateHasVerdelingGezien(false);
      }
    }
    // if (aangifte.verdeling) {
    //     this.updateHasVerdelingGezien(true);
    // }
  }

  calculateHasVerdeling(response: AangifteBerekening): boolean {
    const vermogensGrensVoorRegelingen = this.vermogensGrensVoorRegelingen;

    const saldoEigenWoning = response.box1?.opbouwInkomen?.saldoEigenWoning;
    const saldoAanmerkelijkBelang = response.box2?.opbouwInkomen?.saldoAanmerkelijkBelang;
    const grondslagSparenEnBeleggen = response.box3?.opbouwInkomen?.grondslagSparenEnBeleggen;
    const aftrekbareGiften = response.opbouwPGA?.aftrekbareGiften;
    const specifiekeZorgkosten = response.opbouwPGA?.specifiekeZorgkosten;
    const scholingsuitgaven = response.opbouwPGA?.scholingsuitgaven;
    const weekenduitgaven = response.opbouwPGA?.weekenduitgaven;
    const rendementsGrondslag = response.box3?.opbouwInkomen?.rendementsGrondslag;
    const restantPgaVoorgaandeJaren = response.opbouwPGA?.restantPgaVoorgaandeJaren;
    const onderhoudsverplichtingen = response.opbouwPGA?.onderhoudsverplichtingen;
    const alBetaaldeDividendbelasting = response.alBetaaldeDividendbelasting;
    const alBetaaldeDividendbelastingPartner = response.partnerBerekening?.alBetaaldeDividendbelasting;

    console.log('verdeling1', rendementsGrondslag)
      console.log('verdeling2', rendementsGrondslag)

    return (
      saldoEigenWoning !== 0 && saldoEigenWoning != undefined ||
      saldoAanmerkelijkBelang !== 0 && saldoAanmerkelijkBelang != undefined ||
      (rendementsGrondslag !== 0 && rendementsGrondslag != undefined && rendementsGrondslag > vermogensGrensVoorRegelingen) ||
      grondslagSparenEnBeleggen !== 0 && grondslagSparenEnBeleggen != undefined ||
      aftrekbareGiften !== 0 && aftrekbareGiften != undefined ||
      specifiekeZorgkosten !== 0 && specifiekeZorgkosten != undefined ||
      scholingsuitgaven !== 0 && scholingsuitgaven != undefined ||
      weekenduitgaven !== 0 && weekenduitgaven != undefined ||
      restantPgaVoorgaandeJaren !== 0 && restantPgaVoorgaandeJaren != undefined ||
      onderhoudsverplichtingen !== 0 && onderhoudsverplichtingen != undefined ||
      alBetaaldeDividendbelasting !== 0 && alBetaaldeDividendbelasting != undefined ||
      alBetaaldeDividendbelastingPartner !== 0 && alBetaaldeDividendbelastingPartner != undefined
    );
  }

  public getRapport(aangifte: Aangifte) {
    this.bokkzClient.getIbRapport(aangifte).subscribe({
      next: (result) => {
        this.updateAangifteRapport(result as AangifteRapport);
        if (result.specificatieZorgkosten?.opbouw?.drempelZorgkosten !== undefined) {
          this.updateDrempelZorgkosten(result.specificatieZorgkosten?.opbouw?.drempelZorgkosten);
        }
        if (result.specificatieGiften?.opbouw?.drempelGiften !== undefined) {
          this.updateDrempelGiften(result.specificatieGiften?.opbouw?.drempelGiften);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
    if (aangifte.partnerAangifte) {
      const partnerData = this.convertAangifteToPartnerAangifte(aangifte);
      if (partnerData != undefined) {
        this.getIbRapportPartner(partnerData);
      }
    }
  }

  public getIbRapportPartner(aangifte: Aangifte) {
    this.bokkzClient.getIbRapport(aangifte).subscribe({
      next: (resultPartner) => {
        this.updatePartnerAangifteRapport(resultPartner as AangifteRapport);
      },
      error: (error) => {
        console.log(JSON.stringify(error));
      }
    });
  }

  public createOndernemingFormGroup(onderneming ?: Onderneming): FormGroup {
    return this.fb.group({
      werkzaamheden: onderneming?.werkzaamheden || undefined,
      naam: onderneming?.naam || undefined,
      administratieId: onderneming?.administratieId || undefined,
      ondernemingsvorm: onderneming?.ondernemingsvorm || undefined,
      rsin: onderneming?.rsin || undefined,
      landCode: onderneming?.landCode || undefined,
      invullenOpNiveauSamenwerkingsverband: [onderneming?.invullenOpNiveauSamenwerkingsverband === true ? true : undefined],
      invullenOpPersoonlijkNiveau: [onderneming?.invullenOpPersoonlijkNiveau === true ? true : false],
      invullenOpJaaropgaveCV: onderneming?.invullenOpJaaropgaveCV != null ? onderneming.invullenOpJaaropgaveCV : false,
      zeescheepvaart: onderneming?.zeescheepvaart || undefined,
      startOnderneming: onderneming?.startOnderneming || null as unknown as Date,
      datumStaking: onderneming?.datumStaking || null as unknown as Date,
      staking: onderneming?.staking !== null ? this.createStakingFormGroup(onderneming?.staking) : undefined,
      medegerechtigdeOfSchuldeiser: onderneming?.medegerechtigdeOfSchuldeiser != null ? onderneming.medegerechtigdeOfSchuldeiser : undefined,
      winstUitHoofdeVanSchuldvordering: onderneming?.winstUitHoofdeVanSchuldvordering != null ? onderneming.winstUitHoofdeVanSchuldvordering : undefined,
      agrarischeActiviteiten: onderneming?.agrarischeActiviteiten != null ? onderneming.agrarischeActiviteiten : undefined,
      // specificatieAgrarischeActiviteiten: onderneming?.specificatieAgrarischeActiviteiten != null ? this.createSpecAgrActFG(onderneming?.specificatieAgrarischeActiviteiten) : this.fb.array([]),
      waarderingsstelselGewijzigd: onderneming?.waarderingsstelselGewijzigd != null ? onderneming.waarderingsstelselGewijzigd : undefined,
      willekeurigAfgeschreven: onderneming?.willekeurigAfgeschreven != null ? onderneming.willekeurigAfgeschreven : undefined,
      schadeloosstellingBuitenWinstOm: onderneming?.schadeloosstellingBuitenWinstOm != null ? onderneming.schadeloosstellingBuitenWinstOm : undefined,
      schadeloosstellingBuitenWinst: this.fb.array<OmschrijvingEnBedrag>(onderneming?.schadeloosstellingBuitenWinst || []),

      wuoOpbrengsten: this.fb.array<JaarrekeningVenW>(onderneming?.wuoOpbrengsten || []),
      wuoVrijgesteldeWinstbestanddelen: onderneming?.wuoVrijgesteldeWinstbestanddelen != null ? this.createVrijgesteldeWinstbestanddelenFG(onderneming?.wuoVrijgesteldeWinstbestanddelen) : this.fb.array([]),
      wuoStakingswinsten: onderneming?.datumStaking != null ? this.createWuoStakingsWinstenFormgroup(onderneming?.wuoStakingswinsten) : undefined,
      financieleBaten: this.fb.array<JaarrekeningVenW>(onderneming?.financieleBaten || []),
      buitengewoneBaten: this.fb.array<JaarrekeningVenW>(onderneming?.buitengewoneBaten || []),
      wuoKosten: this.fb.array<JaarrekeningVenW>(onderneming?.wuoKosten || []),
      financieleLasten: this.fb.array<JaarrekeningVenW>(onderneming?.financieleLasten || []),
      buitengewoneLasten: this.fb.array<JaarrekeningVenW>(onderneming?.buitengewoneLasten || []),
      immaterieleVasteActiva: this.fb.array<JaarrekeningBalans>(onderneming?.immaterieleVasteActiva || []),
      materieleVasteActiva: this.fb.array<JaarrekeningBalans>(onderneming?.materieleVasteActiva || []),
      financieleVasteActiva: this.fb.array<JaarrekeningBalans>(onderneming?.financieleVasteActiva || []),
      vlottendeActivaVoorraad: this.fb.array<JaarrekeningBalans>(onderneming?.vlottendeActivaVoorraad || []),
      vlottendeActivaVorderingen: this.fb.array<JaarrekeningBalans>(onderneming?.vlottendeActivaVorderingen || []),
      effecten: this.fb.array<JaarrekeningBalans>(onderneming?.effecten || []),
      liquideMiddelen: this.fb.array<JaarrekeningBalans>(onderneming?.liquideMiddelen || []),
      eigenVermogen: this.fb.array<JaarrekeningBalans>(onderneming?.eigenVermogen || []),
      voorzieningen: this.fb.array<JaarrekeningBalans>(onderneming?.voorzieningen || []),
      specificatieHerinvesteringsreserve: onderneming?.specificatieHerinvesteringsreserve != null ? this.createSpecHIRFG(onderneming?.specificatieHerinvesteringsreserve) : this.fb.array([]),
      langlopendeSchulden: this.fb.array<JaarrekeningBalans>(onderneming?.langlopendeSchulden || []),
      kortlopendeSchulden: this.fb.array<JaarrekeningBalans>(onderneming?.kortlopendeSchulden || []),
      investeringen: onderneming?.investeringen != null ? this.createInvesteringenFG(onderneming?.investeringen) : this.fb.array([]),
      restantInvesteringsaftrek: onderneming?.restantInvesteringsaftrek != null ? this.createRestantInvesteringsaftrekFG(onderneming?.restantInvesteringsaftrek) : this.fb.array([]),
      onttrekkingOG: onderneming?.onttrekkingOG != null ? this.createOnttrekkingOGFG(onderneming?.onttrekkingOG) : this.fb.array([]),
      onttrekkingPriveGebruikAuto: onderneming?.onttrekkingPriveGebruikAuto != null ? this.createOnttrekkingPriveGebruikAutoFG(onderneming?.onttrekkingPriveGebruikAuto) : this.fb.array([]),
      onttrekkingPriveGebruikWoning: onderneming?.onttrekkingPriveGebruikWoning != null ? this.createOnttrekkingPriveGebruikWoningFG(onderneming?.onttrekkingPriveGebruikWoning) : this.fb.array([]),
      onttrekkingenOverig: onderneming?.onttrekkingenOverig != null ? this.createOnttrekkingOverigFG(onderneming?.onttrekkingenOverig) : this.fb.array([]),
      stortingOG: onderneming?.stortingOG != null ? this.createStortingOGFG(onderneming?.stortingOG) : this.fb.array([]),
      stortingenOverig: onderneming?.stortingenOverig != null ? this.createStortingenOverigFG(onderneming?.stortingenOverig) : this.fb.array([]),
      nietAftrekbareKosten: onderneming?.nietAftrekbareKosten != null ? this.createNietAftrekbareKostenFG(onderneming?.nietAftrekbareKosten) : this.fb.array([]),
      beperktAftrekbareKosten: onderneming?.beperktAftrekbareKosten != null ? this.createBeperktAftrekbareKostenFG(onderneming?.beperktAftrekbareKosten) : this.fb.array([]),

      beginstandFOR: onderneming?.beginstandFOR || undefined,
      dotatieFOR: onderneming?.dotatieFOR || undefined,
      vrijvalFOR: onderneming?.vrijvalFOR || undefined,
      beginstandHIR: onderneming?.beginstandHIR != null ? this.createBeginstandHIRFG(onderneming?.beginstandHIR) : this.fb.array([]),
      dotatieHIR: onderneming?.dotatieHIR || undefined,
      vrijvalHIR: onderneming?.vrijvalHIR || undefined,
      beginstandEgalisatiereserve: onderneming?.beginstandHIR != null ? this.createBeginstandKERFG(onderneming?.beginstandEgalisatiereserve) : this.fb.array([]),
      dotatieEgalisatiereserve: onderneming?.dotatieEgalisatiereserve || undefined,
      vrijvalEgalisatiereserve: onderneming?.vrijvalEgalisatiereserve || undefined,
      resultaatSamenwerking: this.createResultaatSamenwerkingFormGroup(onderneming?.resultaatSamenwerking),
      maximumVerliesBepaling: onderneming?.maximumVerliesBepaling || undefined
    });
  }

  private createStakingFormGroup(staking ?: Staking) {
    return this.fb.group({
      stakingDoorOverdrachtOnderneming: staking?.stakingDoorOverdrachtOnderneming ?? false,
      overdrachtOnroerendeZakenNaarPrive: staking?.overdrachtOnroerendeZakenNaarPrive ?? false,
      overdrachtOverigeBestanddelenNaarPrive: staking?.overdrachtOverigeBestanddelenNaarPrive ?? false,
      overdrachtNaarBV: staking?.overdrachtNaarBV ?? false,
      doorschuivenGeruisloosNaarMedeOndernemer: staking?.doorschuivenGeruisloosNaarMedeOndernemer ?? false,
      doorschuivenGeruisloosDoorOverlijden: staking?.doorschuivenGeruisloosDoorOverlijden ?? false,
      doorschuivenGeruisloosInbrengInBV: staking?.doorschuivenGeruisloosInbrengInBV ?? false
    });
  }

  public createOnttrekkingPriveGebruikAutoFG(onttrekkingPriveGebruikAuto ?: SpecificatiePriveGebruikAuto[]) {
    const ondernemingFG = this.fb.group({
      onttrekkingPriveGebruikAuto: this.fb.array([])
    });

    const array = ondernemingFG.get('onttrekkingPriveGebruikAuto') as FormArray;
    if (onttrekkingPriveGebruikAuto != undefined) {
      for (let i = 0; i < onttrekkingPriveGebruikAuto?.length; i++) {
        const group = this.fb.group<SpecificatiePriveGebruikAuto>({
          autoWordtPriveGebruikt: onttrekkingPriveGebruikAuto[i].autoWordtPriveGebruikt || undefined as unknown as boolean,
          kenteken: onttrekkingPriveGebruikAuto[i].kenteken || undefined as unknown as string,
          catalogusPrijs: onttrekkingPriveGebruikAuto[i].catalogusPrijs || undefined as unknown as number,
          periodePriveGebruik: this.fb.group({
            begindatum: onttrekkingPriveGebruikAuto[i].periodePriveGebruik?.begindatum || undefined as unknown as Date,
            einddatum: onttrekkingPriveGebruikAuto[i].periodePriveGebruik?.begindatum || undefined as unknown as Date
          }),
          kilometerAdministratieAanwezig: onttrekkingPriveGebruikAuto[i].kilometerAdministratieAanwezig || undefined as unknown as boolean,
          kostenEnLastenVoorEigenRekening: onttrekkingPriveGebruikAuto[i].kostenEnLastenVoorEigenRekening || undefined as unknown as number,
          priveGebruik: onttrekkingPriveGebruikAuto[i].priveGebruik || undefined as unknown as number
        });
        array.push(group);
      }
    }
    return array;
  }

  private createOnttrekkingOverigFG(onttrekkingOverig ?: OmschrijvingEnBedrag[]) {
    const ondernemingFG = this.fb.group({
      onttrekkingOverig: this.fb.array([])
    });

    const array = ondernemingFG.get('onttrekkingOverig') as FormArray;
    if (onttrekkingOverig != undefined) {
      for (let i = 0; i < onttrekkingOverig?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: onttrekkingOverig[i].omschrijving || undefined as unknown as string,
          bedrag: onttrekkingOverig[i].bedrag || undefined as unknown as number
        });
        array.push(group);
      }
    }
    return array;
  }

  private createOnttrekkingOGFG(onttrekkingOG ?: SpecificatieOnroerendeZaken[]) {
    const ondernemingFG = this.fb.group({
      onttrekkingOG: this.fb.array([])
    });

    const array = ondernemingFG.get('onttrekkingOG') as FormArray;
    if (onttrekkingOG != undefined) {
      for (let i = 0; i < onttrekkingOG?.length; i++) {
        const group = this.fb.group<SpecificatieOnroerendeZaken>({
          adresOnroerendeZaak: this.fb.group({
            straat: onttrekkingOG[i].adresOnroerendeZaak?.straat || undefined as unknown as string,
            huisNummer: onttrekkingOG[i].adresOnroerendeZaak?.huisNummer || undefined as unknown as number,
            huisNummerToevoeging: onttrekkingOG[i].adresOnroerendeZaak?.huisNummerToevoeging || undefined as unknown as string,
            postcode: onttrekkingOG[i].adresOnroerendeZaak?.postcode || undefined as unknown as string,
            woonplaats: onttrekkingOG[i].adresOnroerendeZaak?.woonplaats || undefined as unknown as string,
            landCode: onttrekkingOG[i].adresOnroerendeZaak?.landCode || undefined as unknown as string
          }),
          waardeEconomischeVerkeer: onttrekkingOG[i].waardeEconomischeVerkeer || undefined as unknown as number,
          boekwaardeOpMonentOnttrekking: onttrekkingOG[i].boekwaardeOpMonentOnttrekking || undefined as unknown as number,
          transactieMetDerde: onttrekkingOG[i].transactieMetDerde || undefined as unknown as boolean,
          taxateurBetrokken: onttrekkingOG[i].taxateurBetrokken || undefined as unknown as boolean,
          naamTaxateur: onttrekkingOG[i].naamTaxateur || undefined as unknown as string
        });
        array.push(group);
      }
    }
    return array;
  }

  private createOnttrekkingPriveGebruikWoningFG(onttrekkingPriveGebruikWoning ?: SpecificatiePriveGebruikWoning[]) {
    const ondernemingFG = this.fb.group({
      onttrekkingPriveGebruikWoning: this.fb.array([])
    });

    const array = ondernemingFG.get('onttrekkingPriveGebruikWoning') as FormArray;
    if (onttrekkingPriveGebruikWoning != undefined) {
      for (let i = 0; i < onttrekkingPriveGebruikWoning?.length; i++) {
        const group = this.fb.group<SpecificatiePriveGebruikWoning>({
          adresWoning: this.fb.group({
            straat: onttrekkingPriveGebruikWoning[i].adresWoning?.straat || undefined as unknown as string,
            huisNummer: onttrekkingPriveGebruikWoning[i].adresWoning?.huisNummer || undefined as unknown as number,
            huisNummerToevoeging: onttrekkingPriveGebruikWoning[i].adresWoning?.huisNummerToevoeging || undefined as unknown as string,
            postcode: onttrekkingPriveGebruikWoning[i].adresWoning?.postcode || undefined as unknown as string,
            woonplaats: onttrekkingPriveGebruikWoning[i].adresWoning?.woonplaats || undefined as unknown as string,
            landCode: onttrekkingPriveGebruikWoning[i].adresWoning?.landCode || undefined as unknown as string
          }),
          wozWaarde: onttrekkingPriveGebruikWoning[i].wozWaarde || undefined as unknown as number,
          periodeBewoning: this.fb.group({
            begindatum: onttrekkingPriveGebruikWoning[i].periodeBewoning?.begindatum || undefined as unknown as Date,
            einddatum: onttrekkingPriveGebruikWoning[i].periodeBewoning?.begindatum || undefined as unknown as Date
          }),
          percentageGerechtigd: onttrekkingPriveGebruikWoning[i].percentageGerechtigd || undefined as unknown as number,
          berekendeOnttrekking: onttrekkingPriveGebruikWoning[i].berekendeOnttrekking || undefined as unknown as number
        });
        array.push(group);
      }
    }
    return array;
  }

  private createStortingenOverigFG(stortingenOverig ?: OmschrijvingEnBedrag[]) {
    const ondernemingFG = this.fb.group({
      onttrekkingOverig: this.fb.array([])
    });

    const array = ondernemingFG.get('onttrekkingOverig') as FormArray;
    if (stortingenOverig != undefined) {
      for (let i = 0; i < stortingenOverig?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: stortingenOverig[i] ? stortingenOverig[i].omschrijving : undefined as unknown as string,
          bedrag: stortingenOverig[i] ? stortingenOverig[i].bedrag : undefined as unknown as number
        });
        array.push(group);
      }
    }
    return array;
  }

  private createStortingOGFG(stortingOG ?: SpecificatieOnroerendeZaken[]) {
    const ondernemingFG = this.fb.group({
      onttrekkingOG: this.fb.array([])
    });

    const array = ondernemingFG.get('onttrekkingOG') as FormArray;
    if (stortingOG != undefined) {
      for (let i = 0; i < stortingOG?.length; i++) {
        const group = this.fb.group<SpecificatieOnroerendeZaken>({
          adresOnroerendeZaak: this.fb.group({
            straat: stortingOG[i].adresOnroerendeZaak?.straat || undefined as unknown as string,
            huisNummer: stortingOG[i].adresOnroerendeZaak?.huisNummer || undefined as unknown as number,
            huisNummerToevoeging: stortingOG[i].adresOnroerendeZaak?.huisNummerToevoeging || undefined as unknown as string,
            postcode: stortingOG[i].adresOnroerendeZaak?.postcode || undefined as unknown as string,
            woonplaats: stortingOG[i].adresOnroerendeZaak?.woonplaats || undefined as unknown as string,
            landCode: stortingOG[i].adresOnroerendeZaak?.landCode || undefined as unknown as string
          }),
          waardeEconomischeVerkeer: stortingOG[i].waardeEconomischeVerkeer || undefined as unknown as number,
          taxateurBetrokken: stortingOG[i].taxateurBetrokken || undefined as unknown as boolean,
          naamTaxateur: stortingOG[i].naamTaxateur || undefined as unknown as string
        });
        array.push(group);
      }
    }
    return array;
  }

  private createInvesteringenFG(investeringen ?: JaarrekeningInvesteringen[]) {
    const ondernemingFG = this.fb.group({
      investeringen: this.fb.array([])
    });

    const array = ondernemingFG.get('investeringen') as FormArray;
    if (investeringen != undefined) {
      for (let i = 0; i < investeringen?.length; i++) {
        const group = this.fb.group<JaarrekeningInvesteringen>({
          omschrijving: investeringen[i]?.omschrijving || '',
          datumIngebruikname: investeringen[i] ? investeringen[i].datumIngebruikname : undefined,
          aandeelInInvesteringsBedrag: investeringen[i] ? investeringen[i].aandeelInInvesteringsBedrag : undefined,
          claimEIA: investeringen[i] ? investeringen[i].claimEIA : undefined,
          investeringsbedragEIA: investeringen[i] ? investeringen[i].investeringsbedragEIA : undefined,
          meldingsNummerEia: investeringen[i] ? investeringen[i].meldingsNummerEia : undefined,
          claimMIA: investeringen[i] ? investeringen[i].claimMIA : undefined,
          investeringsbedragMIA: investeringen[i] ? investeringen[i].investeringsbedragMIA : undefined,
          meldingsNummerMia: investeringen[i] ? investeringen[i].meldingsNummerMia : undefined,
          miaLetter: investeringen[i] ? investeringen[i].miaLetter : undefined,
          claimKIA: investeringen[i] ? investeringen[i].claimKIA : undefined,
          investeringsbedragKIA: investeringen[i] ? investeringen[i].investeringsbedragKIA : undefined,
          reedsBetaaldDoorAangever: investeringen[i] ? investeringen[i].reedsBetaaldDoorAangever : undefined,
          grondslagDesinvestering: investeringen[i] ? investeringen[i].grondslagDesinvestering : undefined,
          percentageInvesteringsaftrek: investeringen[i] ? investeringen[i].percentageInvesteringsaftrek : undefined
        });
        array.push(group);
      }
    }
    return array;
  }

  private createNietAftrekbareKostenFG(nietAftrekbareKosten: OmschrijvingEnBedrag[] | undefined) {
    const ondernemingFG = this.fb.group({
      nietAftrekbareKosten: this.fb.array([])
    });

    const array = ondernemingFG.get('nietAftrekbareKosten') as FormArray;
    if (nietAftrekbareKosten != undefined) {
      for (let i = 0; i < nietAftrekbareKosten?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: nietAftrekbareKosten[i] ? nietAftrekbareKosten[i].omschrijving : undefined,
          bedrag: nietAftrekbareKosten[i] ? nietAftrekbareKosten[i].bedrag : undefined
        });
        array.push(group);
      }
    }
    return array;
  }

  private createBeperktAftrekbareKostenFG(beperktAftrekbareKosten: OmschrijvingEnBedrag[] | undefined) {
    const ondernemingFG = this.fb.group({
      nietAftrekbareKosten: this.fb.array([])
    });

    const array = ondernemingFG.get('nietAftrekbareKosten') as FormArray;
    if (beperktAftrekbareKosten != undefined) {
      for (let i = 0; i < beperktAftrekbareKosten?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: beperktAftrekbareKosten[i] ? beperktAftrekbareKosten[i].omschrijving : undefined,
          bedrag: beperktAftrekbareKosten[i] ? beperktAftrekbareKosten[i].bedrag : undefined
        });
        array.push(group);
      }
    }
    return array;
  }

  private createVrijgesteldeWinstbestanddelenFG(wuoVrijgesteldeWinstbestanddelen: JaarrekeningVenW[] | undefined) {
    const ondernemingFG = this.fb.group({
      wuoVrijgesteldeWinstbestanddelen: this.fb.array([])
    });

    const array = ondernemingFG.get('wuoVrijgesteldeWinstbestanddelen') as FormArray;
    if (wuoVrijgesteldeWinstbestanddelen != undefined) {
      for (let i = 0; i < wuoVrijgesteldeWinstbestanddelen?.length; i++) {
        const group = this.fb.group<JaarrekeningVenW>({
          omschrijving: wuoVrijgesteldeWinstbestanddelen[i] ? wuoVrijgesteldeWinstbestanddelen[i].omschrijving : undefined,
          bedrag: wuoVrijgesteldeWinstbestanddelen[i] ? wuoVrijgesteldeWinstbestanddelen[i].bedrag : undefined
        });
        array.push(group);
      }
    }
    return array;
  }

  private createWuoStakingsWinstenFormgroup(wuoStakingsWinsten: JaarrekeningVenW[] | undefined) {
    const ondernemingFG = this.fb.group({
      wuoStakingsWinsten: this.fb.array([])
    });

    const array = ondernemingFG.get('wuoStakingsWinsten') as FormArray;
    if (wuoStakingsWinsten != undefined) {
      for (let i = 0; i < wuoStakingsWinsten?.length; i++) {
        const group = this.fb.group<JaarrekeningVenW>({
          omschrijving: wuoStakingsWinsten[i] ? wuoStakingsWinsten[i].omschrijving : undefined,
          bedrag: wuoStakingsWinsten[i] ? wuoStakingsWinsten[i].bedrag : undefined
        });
        array.push(group);
      }
    }
    return array;
  }

  private createRestantInvesteringsaftrekFG(restantInvesteringsaftrek: OmschrijvingEnBedrag[] | undefined) {
    const ondernemingFG = this.fb.group({
      restantInvesteringsaftrek: this.fb.array([])
    });

    const array = ondernemingFG.get('restantInvesteringsaftrek') as FormArray;
    if (restantInvesteringsaftrek != undefined) {
      for (let i = 0; i < restantInvesteringsaftrek?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: restantInvesteringsaftrek[i] ? restantInvesteringsaftrek[i].omschrijving : undefined,
          bedrag: restantInvesteringsaftrek[i] ? restantInvesteringsaftrek[i].bedrag : undefined
        });
        array.push(group);
      }
    }
    return array;
  }

  private createBeginstandHIRFG(beginstandHIR: OmschrijvingEnBedrag[] | undefined) {
    const ondernemingFG = this.fb.group({
      beginstandHIR: this.fb.array([])
    });

    const array = ondernemingFG.get('beginstandHIR') as FormArray;
    if (beginstandHIR != undefined) {
      for (let i = 0; i < beginstandHIR?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: beginstandHIR[i] ? beginstandHIR[i].omschrijving : '',
          bedrag: beginstandHIR[i] ? beginstandHIR[i].bedrag : 0
        });
        array.push(group);
      }
    }
    return array;
  }

  private createBeginstandKERFG(beginstandEgalisatiereserve: OmschrijvingEnBedrag[] | undefined) {
    const ondernemingFG = this.fb.group({
      beginstandEgalisatiereserve: this.fb.array([])
    });

    const array = ondernemingFG.get('beginstandEgalisatiereserve') as FormArray;
    if (beginstandEgalisatiereserve != undefined) {
      for (let i = 0; i < beginstandEgalisatiereserve?.length; i++) {
        const group = this.fb.group<OmschrijvingEnBedrag>({
          omschrijving: beginstandEgalisatiereserve[i] ? beginstandEgalisatiereserve[i].omschrijving : undefined as unknown as string,
          bedrag: beginstandEgalisatiereserve[i] ? beginstandEgalisatiereserve[i].bedrag : undefined as unknown as number
        });
        array.push(group);
      }
    }
    return array;
  }

  private createSpecHIRFG(specificatieHerinvesteringsreserve: Herinvesteringsreserve[] | undefined) {
    const ondernemingFG = this.fb.group({
      specificatieHerinvesteringsreserve: this.fb.array([])
    });
    const array = ondernemingFG.get('specificatieHerinvesteringsreserve') as FormArray;
    if (specificatieHerinvesteringsreserve != undefined) {
      for (let i = 0; i < specificatieHerinvesteringsreserve?.length; i++) {
        const group = this.fb.group<Herinvesteringsreserve>({
          omschrijving: specificatieHerinvesteringsreserve[i]?.omschrijving || '',
          jaarVanVervreemding: specificatieHerinvesteringsreserve[i] ? specificatieHerinvesteringsreserve[i].jaarVanVervreemding : null as unknown as number,
          boekwinst: specificatieHerinvesteringsreserve[i] ? specificatieHerinvesteringsreserve[i].boekwinst : null as unknown as number,
          afschrijvingspercentage: specificatieHerinvesteringsreserve[i] ? specificatieHerinvesteringsreserve[i].afschrijvingspercentage : null as unknown as number,
          boekwaardeOpVervreemdingsmoment: specificatieHerinvesteringsreserve[i] ? specificatieHerinvesteringsreserve[i].boekwaardeOpVervreemdingsmoment : null as unknown as number
        });
        array.push(group);
      }
    }
    return array;
  }

  public createResultaatSamenwerkingFormGroup(resultaatSamenwerking?: ResultaatSamenwerking): FormGroup {
    return this.fb.group({
      aandeelBelastingplichtigeInKapitaalVolgensContract: [
        resultaatSamenwerking?.aandeelBelastingplichtigeInKapitaalVolgensContract ?? 0
      ],
      aandeelBelastingplichtigeInKapitaalOverig: [
        resultaatSamenwerking?.aandeelBelastingplichtigeInKapitaalOverig ?? 0
      ],
      aandeelBelastingplichtigeInBeginVermogen: [
        resultaatSamenwerking?.aandeelBelastingplichtigeInBeginVermogen ?? 0
      ],
      vergoedingVoorArbeidBelastingplichtige: [
        resultaatSamenwerking?.vergoedingVoorArbeidBelastingplichtige ?? 0
      ],
      overigeVergoedingenBelastingplichtige: [
        resultaatSamenwerking?.overigeVergoedingenBelastingplichtige ?? 0
      ],
      aandeelRestantWinstBelastingplichtige: [
        resultaatSamenwerking?.aandeelRestantWinstBelastingplichtige ?? 0
      ],
      totaalResultaat: [{value: 0, disabled: true}]
    });
  }

  private winstResultatenrekeningSource = new BehaviorSubject<number>(0);
  winstResultatenrekening = this.winstResultatenrekeningSource.asObservable();

  setWinstResultatenrekening(value: number): void {
    this.winstResultatenrekeningSource.next(value);
  }

  searchAnbi(query: Search): Observable<AnbiAntwoord[]> {
    return this.http.post<AnbiAntwoord[]>(this.apiAnbiUrl, query);
  }

  getKentekenGegevens(kenteken: string, privebetaald: number, beginDatum: string, eindDatum: string): Observable<Kenteken[]> {
    const url = `${this.baseUrl}/api/v1/sst/kenteken/${kenteken}/${privebetaald}/${beginDatum}/${eindDatum}`;
    return this.http.get<Kenteken[]>(url);
  }

  ngOnDestroy(): void {
    if (this.menuInterface) {
      this.menuInterface?.unsubscribe();
    }
    if (this.errorResponse) {
      this.errorResponse?.unsubscribe();
    }
    if (this.aantalValidaties) {
      this.aantalValidaties?.unsubscribe();
    }
    if (this.incomeTaxEntity) {
      this.incomeTaxEntity.unsubscribe();
    }
  }

  private fixOwr(aangifte: Aangifte): void {
      const box3 = aangifte.box3;
      if (!box3) return;

      box3.berekenWerkelijkRendement = false;

      box3.bankrekeningen?.forEach((b) => {
          b.directRendement = undefined;
          b.valutaResultaat = undefined;
          b.waardeEindJaar = undefined;
          b.stortingen = undefined;
          b.onttrekkingen = undefined;
      });

      box3.beleggingsrekeningen?.forEach((b) => {
          b.directRendement = undefined;
          b.valutaResultaat = undefined;
          b.waardeEindJaar = undefined;
          b.stortingen = undefined;
          b.onttrekkingen = undefined;
      });

      box3.groeneBeleggingen?.forEach((b) => {
          b.directRendement = undefined;
          b.valutaResultaat = undefined;
          b.waardeEindJaar = undefined;
          b.stortingen = undefined;
          b.onttrekkingen = undefined;
      });

      box3.overigeOnroerendeZaken?.forEach((b) => {
          b.directRendement = undefined;
          b.betaaldeErfpachtCanonEindeJaar = undefined;
          b.verhuurdOfVerpachtOpEinddatum = undefined;
          b.investeringen = undefined;
          b.waardestijgingWOZwaardeWegensInvesteringen = undefined;
          b.woning = undefined;
          b.directRendement = undefined;
      });

      box3.overigeBezittingen?.forEach((b) => {
          b.directRendement = undefined;
          b.waardeEindJaar = undefined;
          b.toenames = undefined;
          b.afnames = undefined;
      });

      box3.leningen?.forEach((b) => {
          b.bijzondereWaardevermindering = undefined;
      });

  }

  private schoonAangifte(aangifte: Aangifte) {

    // if (aangifte.box1) {
    //     if (aangifte.box1.winstUitOnderneming && Object.keys(aangifte.box1?.winstUitOnderneming).length === 0) {
    //         aangifte.box1.winstUitOnderneming = undefined
    //     }
    //     if (aangifte.box1.belastbaarLoon && Object.keys(aangifte.box1?.belastbaarLoon).length === 0) {
    //         aangifte.box1.belastbaarLoon = undefined
    //     }
    //     if (aangifte.box1.resultaatUitOverigeWerkzaamheden && Object.keys(aangifte.box1?.resultaatUitOverigeWerkzaamheden).length === 0) {
    //         aangifte.box1.resultaatUitOverigeWerkzaamheden = undefined
    //     }
    //     if (aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen && Object.keys(aangifte.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen).length === 0) {
    //         aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen = undefined
    //     }
    //     if (aangifte.box1.belastbareInkomstenUitEigenWoning && Object.keys(aangifte.box1?.belastbareInkomstenUitEigenWoning).length === 0) {
    //         aangifte.box1.belastbareInkomstenUitEigenWoning = undefined
    //     }
    //     if (aangifte.box1.uitgavenVoorInkomensvoorzieningen && Object.keys(aangifte.box1?.uitgavenVoorInkomensvoorzieningen).length === 0) {
    //         aangifte.box1.uitgavenVoorInkomensvoorzieningen = undefined
    //     }
    //     if (aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen && Object.keys(aangifte.box1?.negatieveUitgavenVoorInkomensvoorzieningen).length === 0) {
    //         aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen = undefined
    //     }
    //     if (aangifte.box1.negatievePersoonsgebondenAftrek && Object.keys(aangifte.box1?.negatievePersoonsgebondenAftrek).length === 0) {
    //         aangifte.box1.negatievePersoonsgebondenAftrek = undefined
    //     }
    //     if (aangifte.box1.belastbareInkomstenOpBasisVanOvergangsrecht && Object.keys(aangifte.box1?.belastbareInkomstenOpBasisVanOvergangsrecht).length === 0) {
    //         aangifte.box1.belastbareInkomstenOpBasisVanOvergangsrecht = undefined
    //     }
    // }
    // if (aangifte.box1 && Object.keys(aangifte.box1).length === 0) {
    //     aangifte.box1 = undefined
    // }
    //
    // if (aangifte.box1 && aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen) {
    //     if (aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen.terugontvangenPremieAOV == 0) {
    //         aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen.terugontvangenPremieAOV = undefined
    //     }
    //     if (aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen.terugontvangenPremieLijfrente == 0) {
    //         aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen.terugontvangenPremieLijfrente = undefined
    //     }
    //     if (Object.keys(aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen).length === 0) {
    //         aangifte.box1.negatieveUitgavenVoorInkomensvoorzieningen = undefined
    //     }
    // }

    return aangifte;
  }

  private bepaalVerdelingRendementsGrondslag(result: AangifteBerekening, aangifte: Aangifte) {

    // We zorgen ervoor dat aangifte niet null of undefined is
    if (!aangifte || !aangifte.partnerAangifte) {
      return false;
    }

    // Gebruik een object voor de vermogensgrenzen per jaar
    const vermogensGrensVoorRegelingen: Record<number, number> = {
      2024: 73904,
      2025: 74790,
      2026: 76958
    };

    // Haal de juiste grens op voor het jaar, of 0 als het jaar niet in de lijst zit
    const grens = vermogensGrensVoorRegelingen[aangifte.aangifteJaar] ?? 0;

    // Check of het vermogen boven de grens ligt
    const rendementsGrondslag = result.box3?.opbouwInkomen?.rendementsGrondslag;
    const grondslagSparenEnBeleggen = result.box3?.opbouwInkomen?.grondslagSparenEnBeleggen;

    // Kijk of er geen grondslagSparenEnBeleggen is en er wel een rendementsGrondslag is
    if (grondslagSparenEnBeleggen == null && rendementsGrondslag != null) {
      return rendementsGrondslag > grens;
    }

    return false;
  }

  private createIsVerzoek(incomeTaxEntity: IncomeTaxEntity): boolean {
    return incomeTaxEntity.taxType === "VA";
  }

  private convertAangifteToPartnerAangifte(aangifte: Aangifte): Aangifte {
    if (aangifte.partnerAangifte) {
      const partnerAangifte = structuredClone(aangifte.partnerAangifte);
      partnerAangifte.partnerAangifte = structuredClone(aangifte);
      partnerAangifte.partnerAangifte.partnerAangifte = undefined;

      if (partnerAangifte.kinderen == null && aangifte.kinderen != null) {
        partnerAangifte.kinderen = [];
        for (const k of aangifte.kinderen) {
          const partnerKind = {} as Kind;
          partnerKind.voornaam = k.voornaam;
          partnerKind.geboortedatum = k.geboortedatum;
          partnerKind.bsn = k.bsn;
          partnerKind.datumOverlijden = k.datumOverlijden;
          partnerKind.ingeschrevenOpAdresAangever =
            k.ingeschrevenOpAdresPartner != undefined
              ? k.ingeschrevenOpAdresPartner
              : false;
          partnerKind.ingeschrevenOpAdresPartner =
            k.ingeschrevenOpAdresAangever;
          partnerKind.bijExWoonAdres = k.bijExWoonAdres;
          partnerKind.coOuderschap = k.coOuderschap;
          partnerKind.tenMinsteDrieDagenPerWeekWoonachtig =
            k.tenMinsteDrieDagenPerWeekWoonachtig;
          partnerKind.ouderOntvangtKinderbijslag = k.ouderOntvangtKinderbijslag;
          partnerKind.onderhoudBelangrijkeMate = k.onderhoudBelangrijkeMate;
          partnerAangifte.kinderen.push(partnerKind);
        }
      }

      if (
        partnerAangifte.box1 != null &&
        partnerAangifte.box1.belastbareInkomstenUitEigenWoning == null &&
        aangifte.box1 != null &&
        aangifte.box1.belastbareInkomstenUitEigenWoning != null
      ) {
        partnerAangifte.box1.belastbareInkomstenUitEigenWoning =
          aangifte.box1.belastbareInkomstenUitEigenWoning;
      }

      if (partnerAangifte.box2 == null && aangifte.box2 != null) {
        partnerAangifte.box2 = aangifte.box2;
        partnerAangifte.partnerAangifte.box2 = undefined;
      }

      if (partnerAangifte.box3 == null && aangifte.box3 != null) {
        partnerAangifte.box3 = aangifte.box3;
        partnerAangifte.partnerAangifte.box3 = undefined;
      }

      if (
        partnerAangifte.persoonsgebondenAftrek == null &&
        aangifte.persoonsgebondenAftrek != null
      ) {
        partnerAangifte.persoonsgebondenAftrek =
          aangifte.persoonsgebondenAftrek;
        partnerAangifte.partnerAangifte.persoonsgebondenAftrek = undefined;
      }

      const aangeverVoorheffingen = aangifte.voorheffingen;

      if (partnerAangifte.voorheffingen == null) {
        if (
          aangeverVoorheffingen != null &&
          aangeverVoorheffingen.ingehoudenDividendbelasting != null
        ) {
          partnerAangifte.voorheffingen = {} as Voorheffingen;
          partnerAangifte.voorheffingen.ingehoudenDividendbelasting =
            aangeverVoorheffingen.ingehoudenDividendbelasting;
        }

        if (
          aangeverVoorheffingen != null &&
          aangeverVoorheffingen.buitenlandseBronheffing != null
        ) {
          if (partnerAangifte.voorheffingen == null) {
            partnerAangifte.voorheffingen = {} as Voorheffingen;
          }
          partnerAangifte.voorheffingen.buitenlandseBronheffing =
            aangeverVoorheffingen.buitenlandseBronheffing;
        }
      } else {
        if (
          partnerAangifte.voorheffingen.ingehoudenDividendbelasting == null &&
          aangeverVoorheffingen != null &&
          aangeverVoorheffingen.ingehoudenDividendbelasting != null
        ) {
          partnerAangifte.voorheffingen.ingehoudenDividendbelasting =
            aangeverVoorheffingen.ingehoudenDividendbelasting;
        }

        if (
          partnerAangifte.voorheffingen.buitenlandseBronheffing == null &&
          aangeverVoorheffingen != null &&
          aangeverVoorheffingen.buitenlandseBronheffing != null
        ) {
          partnerAangifte.voorheffingen.buitenlandseBronheffing =
            aangeverVoorheffingen.buitenlandseBronheffing;
        }

        if (partnerAangifte.verdeling != null && aangifte.verdeling != null) {
          partnerAangifte.verdeling = aangifte.partnerAangifte.verdeling;
          partnerAangifte.partnerAangifte.verdeling =
            aangifte.verdeling;
        }
      }

      partnerAangifte.gezamenlijkeAangifte = aangifte.gezamenlijkeAangifte;
      partnerAangifte.aangever.burgerlijkeStaat =
        aangifte.aangever.burgerlijkeStaat;
      return partnerAangifte;
    }
    return aangifte;
  }

}

export interface Search {
  search: Zoek[];
}

export interface Zoek {
  zoekOpdrachtType: string,
  zoekWaarde: string
}

export interface AnbiAntwoord {
  fiscaalNummer: number,
  dossierNummer: number,
  naam: string,
  aliasNaam: string,
  vestigingsPlaats: string,
  webSite: string,
  ingangsDatum: string,
  ingangsDatumCultuur: string,
  eindDatum: string,
  intrekkingsDatum: string
  eindDatumCultuur: string
  intrekkingsDatumCultuur: string
}

export interface Kenteken {
  kenteken?: string;
  catalogusprijs?: string;
  datum_tenaamstelling?: string;
  bijtelling?: number;
  bijtellingsPercentage?: number;
  co2_uitstoot_gecombineerd?: number;
}
